<template>
  <div id="app" v-wechat-title="$route.meta.title= pageTitle" :class="theme" @touchstart = "touchStartFun" @touchmove="touchMoveFun" @touchend="touchEndFun">
    <!-- 顶部购物车 -->
    <div class="shoppingCat_title">
      <!-- <span class="shoppingCat_back" @click="switchTo('/home')"></span> -->
      <span class="shoppingCat_back" @click="goLink()"></span>
      <span class="shoppingCat_text">{{ gouwuche }}</span>
      <span
        class="shoppingCat_management"
        @click.stop="managementClick(flgManagement)"
        v-if="ifDate"
      >
        <span>{{ flgManagement == 1 ? guanli : wancheng }}</span>
      </span>
    </div>
    <div :class="rotaryTableFlg ? 'container reduceTopValue' : 'container'">
      <!-- 有数据显示的内容 -->
      <div class="shopping_ifNotEmpty" v-if="ifDate">
        <!-- 购物满一定价格可获得转盘机会 -->
        <div
          class="rotaryTable"
          v-show="rotaryTableFlg"
          @click="openRotary"
          v-if="acvityList.length"
        >
          <span v-html="acvityList[0]"></span>
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/down.png" alt="下拉" />
        </div>
        <!-- 内容 -->
        <div class="shoppingCat_content" v-for="(item,index) in allPrudctList" :key="index">
          <!-- 下部购物车商品 -->
          <!-- 根据是否有满减的状态来显示border -->

          <!-- 顶部全选、店铺名称、优惠券 -->
          <div class="shoppingCat_contentTop">
            <!-- <div
              class="notClickRadio"
              v-if="item.shop_info.length == 1"
            ></div>-->
            <!-- 可点击单选框 -->
            <div
              :class=" item.ifShow == 1 ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
              @click.stop="checkRadio(index)"
              v-if="item.shopIfChange!=0 || (item.shopIfChange == 0 && flgManagement != 1)"
            >
              <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/check.png" alt="check" v-show="item.ifShow == 1" />
            </div>

            <!-- 不可点击 -->
            <div
              class="shoppingContent_radio notInventory"
              v-if="item.shopIfChange == 0 && flgManagement == 1"
            ></div>

            <!-- 商铺名称或者自营 -->
            <div class="shoppingContent_status" v-if="item.shop_name !=''">
              <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/shopping.png" alt="shopping" />
              <span>{{ item.shop_name }}</span>
            </div>
            <div class="shoppingContent_status" v-else>
              <span>{{ quanxuan }}</span>
            </div>
            <!-- 优惠券 -->
            <div
              class="shoppingContent_quan"
              @click.stop="vouchersClick(item.shop_id)"
              v-if="item.is_have_coupon == 1"
            >
              <span>{{ daijinquan }}</span>
            </div>
          </div>

          <div
            v-for="(itemSecond,indexSecond) in item.shop_info"
            :key="indexSecond"
            class="shoppingCat_main"
          >
            <!-- 商品 -->
            <div
              :class=" itemSecond.rule_type != 0 ? 'shoppingCat_mainBox' : ' shoppingCat_mainBox shoppingMain_BoxBorder' "
              v-for="(itemThree,indexThree) in itemSecond.pro_list"
              :key="indexThree"
            >
              <!-- 满减,微团购,限时购 -->
              <div class="shoppingMain_bulkTime">
                <!-- 满减 -->
                <div
                  class="shoppingMain_bulk"
                  v-if="itemSecond.rule_type == 2 && indexThree == 0"
                  @click="xiangqingPopup(index,indexSecond,indexThree,itemThree.pro_type,itemSecond.rule_type)"
                >
                  <div class="shoppingMain_bulkLeft">
                    <span>{{ itemSecond.rule_tag }}</span>
                  </div>
                  <div class="shoppingMain_bulkReduction">
                    <span v-html="itemSecond.rule_info"></span>
                  </div>
                  <div class="shoppingMain_bulkDetail">
                    <span>{{ xiangqing }}</span>
                    <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="right" />
                  </div>
                </div>

                <!-- 微团购(1),限时购(4) -->
                <div
                  class="shoppingMain_time"
                  :class="{ xianshigou_style: indexThree != 0 && itemSecond.pro_list[indexThree - 1].pro_type !=5 && item.shop_info[indexSecond].rule_type ==0}"
                  v-else-if="itemThree.pro_type == 1 || itemThree.pro_type == 4 "
                >
                  <div class="shoppingMain_timeLeft">
                    <span>{{ itemThree.pro_tag }}</span>
                  </div>
                  <div class="shoppingMain_timeRight">
                    <span v-if="itemThree.pro_time_range == 0 && itemThree.JsonTime != undefined">
                      <span v-if="itemThree.JsonTime.days<2">
                        <span class="shoppingMain_timeText" v-text="juhuodongjieshuhaisheng"></span>
                        <span
                          class="shoppingMain_timeDate"
                          v-text="((parseInt(itemThree.JsonTime.hours) + parseInt(itemThree.JsonTime.days * 24)) < 10 ? '0'+(parseInt(itemThree.JsonTime.hours) + parseInt(itemThree.JsonTime.days * 24)) : parseInt(itemThree.JsonTime.hours) + parseInt(itemThree.JsonTime.days * 24)) "
                        ></span> :
                        <span
                          class="shoppingMain_timeDate"
                          v-text="itemThree.JsonTime.minutes<10?'0'+itemThree.JsonTime.minutes : itemThree.JsonTime.minutes"
                        ></span> :
                        <span
                          class="shoppingMain_timeDate"
                          v-text="itemThree.JsonTime.seconds<10? '0'+itemThree.JsonTime.seconds:itemThree.JsonTime.seconds"
                        ></span>
                      </span>

                      <span v-else>
                        <span class="shoppingMain_timeText" v-text="huodongjiezhizhi"></span>
                        <span v-text="itemThree.end_time.slice(0,10)">{{ itemThree.end_time }}</span>
                      </span>
                    </span>
                    <span v-else>
                      <span class="shoppingMain_timeText">{{ itemThree.explain_info.active }}</span>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 批发(组) -->
              <div
                class="shoppingMain_bulkTime"
                v-if="itemSecond.rule_type == 1 && indexThree==0"
                @click.stop="wholesaleClick(index,indexSecond,indexThree,1)"
              >
                <div
                  :class=" itemSecond.is_pifaZu == 1?'shoppingContent_checkRadio shoppingContent_shopRadio' : 'shoppingContent_shopRadio'"
                  @click.stop="selectedCurrentRadio(index,indexSecond,indexThree,1)"
                  v-if="itemSecond.whole_is_buy == 1 && flgManagement == 1"
                >
                  <img
                    src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/check.png"
                    alt="check"
                    v-if="itemSecond.is_pifaZu == 1"
                  />
                </div>

                <div
                  class="notClickRadio"
                  @click.stop
                  v-if=" itemSecond.whole_is_buy == 0 && flgManagement == 1"
                ></div>

                <div class="shoppingMain_bulk">
                  <div class="shoppingMain_bulkLeft" style="background-color:#FF3D2B">
                    <span>{{ itemSecond.rule_tag }}</span>
                  </div>
                  <div class="shoppingMain_bulkReduction">
                    <span v-html="itemSecond.rule_info"></span>
                  </div>
                  <div class="shoppingMain_bulkDetail">
                    <span style="margin-right:0.3rem">{{ itemSecond.add_rule_info }}</span>
                    <span>{{ xiangqing }}</span>
                    <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="right" />
                  </div>
                </div>
              </div>

              <!-- 批发(单个) -->
              <div
                class="shoppingMain_bulkTime"
                v-if="itemSecond.rule_type != '1' && itemThree.pro_type == '5'"
                @click.stop="wholesaleClick(index,indexSecond,indexThree,2)"
              >
                <div class="shoppingMain_bulk">
                  <div class="shoppingMain_bulkLeft" style="background-color:#FF3D2B">
                    <span>{{ itemThree.pro_tag }}</span>
                  </div>
                  <div class="shoppingMain_bulkReduction">
                    <span v-html="itemThree.explain_info.active"></span>
                  </div>
                  <div class="shoppingMain_bulkDetail">
                    <span style="margin-right:0.3rem">{{ itemThree.explain_info.active_add }}</span>
                    <span>{{ xiangqing }}</span>
                    <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="right" />
                  </div>
                </div>
              </div>
              <!-- :class="{shoppingMain_BoxMain_on: indexThree == itemSecond.pro_list.length -1 && itemSecond.rule_type != 0 && (indexSecond != item.shop_info.length -1 || itemThree.pro_type == 4)}" -->
                <!-- :class="{shoppingMain_BoxMain_on: (indexThree == itemSecond.pro_list.length -1 && (itemThree.pro_type == 5 || itemThree.pro_type == 0 || itemThree.pro_type == 2 || itemSecond.rule_type == 2)) || (itemSecond.rule_type == 0 && itemThree.pro_type == 5 && indexThree != itemSecond.pro_list.length -1) || ( itemSecond.pro_list[indexThree+1] != undefined && (itemSecond.pro_list[indexThree+1].pro_type != 1 || itemSecond.pro_list[indexThree+1].pro_type != 4))  }" -->
              <!-- && ( itemSecond.pro_list[indexThree+1] != undefined && (itemSecond.pro_list[indexThree+1].pro_type != 1 && itemSecond.pro_list[indexThree+1].pro_type != 4))  -->
              <div
                class="shoppingMain_BoxMain"
                :class="{shoppingMain_BoxMain_on: ((indexThree == itemSecond.pro_list.length -1 && (itemThree.pro_type == 5 || itemThree.pro_type == 0 || itemThree.pro_type == 2 || itemSecond.rule_type == 2)) || (itemSecond.rule_type == 0 && itemThree.pro_type == 5 && indexThree != itemSecond.pro_list.length -1))  }"
              >
                <div class="shoppingMain_Box">
                  <!-- 商品图片 -->
                  <div class="shoppingMain_picture">
                    <div class="shoppingMain_pictureBox">
                      <img
                        :src="itemThree.pro_pic"
                        alt="图片"
                        @click="goDetailPage(itemThree.pro_href,itemThree.param_id)"
                      />
                      <!-- 已售罄 -->
                      <div class="shoppingMain_pictureOver" v-if=" itemThree.pro_stock <= 0 ">
                        <span>{{ yishouqing}}</span>
                      </div>
                      <!-- 单选框 -->
                      <!-- v-if="(itemSecond.rule_type == 0 && itemSecond.pro_list.length == 1 && itemThree.is_buy == '1') || (itemSecond.rule_type != 1 && itemThree.is_buy == '1')" -->

                      <div
                        :class=" itemThree.is_check == 1 ? 'shoppingContent_checkRadio shoppingContent_shopRadio' : 'shoppingContent_shopRadio'"
                        @click.stop="selectedCurrentRadio(index,indexSecond,indexThree,2)"
                        v-if="itemSecond.rule_type != 1 && itemThree.is_buy == '1'"
                      >
                        <img
                          src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/check.png"
                          alt="check"
                          v-show="itemThree.is_check == 1"
                        />
                      </div>
                      <div
                        class="shoppingContent_shopRadio notInventory"
                        v-if="itemThree.is_buy == 0 && itemSecond.rule_type != 1 && flgManagement==1"
                      ></div>
                      <!-- 这个是用来判断当点击了管理,批发组出来的按钮,只针对于批发组 -->
                      <div
                        :class=" itemThree.is_check == 1 ? 'shoppingContent_checkRadio shoppingContent_shopRadio' : 'shoppingContent_shopRadio'"
                        @click.stop="selectedCurrentRadio(index,indexSecond,indexThree,2)"
                        v-if="(itemSecond.rule_type == 1 || itemThree.is_buy == 0) && flgManagement==2 "
                      >
                        <img
                          src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/check.png"
                          alt="check"
                          v-if="itemThree.is_check == 1 ? true : false"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 商品信息 -->
                  <div class="shoppingMain_information">
                    <div class="shoppingMain_informationTop">
                      <!-- 标题 -->
                      <div
                        class="shoppingMain_title"
                        @click="goDetailPage(itemThree.pro_href,itemThree.param_id)"
                      >{{ itemThree.pro_name }}</div>
                      <!-- 规格 -->
                      <div
                        class="shoppingMain_status"
                        @click="shoppingStatusBtn(index,indexSecond,indexThree)"
                        v-if="itemThree.param_name != '' && flgManagement == 1"
                      >
                        <span class="shoppingMain_statusText" v-html="itemThree.param_name"></span>
                        <span class="shoppingMain_statusArrow"></span>
                      </div>

                      <div
                        class="shoppingMain_status"
                        v-if="itemThree.param_name != '' && flgManagement == 2"
                      >
                        <span class="shoppingMain_statusText" v-html="itemThree.param_name"></span>
                        <span class="shoppingMain_statusArrow"></span>
                      </div>
                    </div>
                    <div class="shoppingMain_informationCenter" v-if="itemThree.jifen_must_num > 0">
                      <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/warn.png" alt="warn" />
                      <span>{{bixushiyong}}{{ itemThree.jifen_must_num }}{{ xf_name }}</span>
                    </div>

                    <!-- 价钱 -->
                    <div class="shoppingMain_price">
                      <div class="shoppingMain_priceBox">
                        <span>
                          <span class="smallText" v-html="currency_symbol"></span>
                          {{ itemThree.pro_price }}
                        </span>
                      </div>
                      <!-- 加减 -->
                      <div class="shoppingMain_priceNum" v-if=" itemThree.is_reelect == 0">
                        <div
                          class="shoppingMain_priceReduce"
                          @click.stop="reduceNumber(index,indexSecond,indexThree)"
                        >
                          <img
                            src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceNo.png"
                            alt="reduce"
                            v-show="itemThree.pro_num <= 1"
                          />
                          <img
                            src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceYes.png"
                            alt="reduce"
                            v-show="itemThree.pro_num > 1"
                          />
                        </div>
                        <div class="shoppingMain_priceInput">
                          <input
                            type="number"
                            v-model="itemThree.pro_num"
                            @click.stop="numbersFocus(index,indexSecond,indexThree)"
                            readonly="readonly"
                          />
                        </div>
                        <div
                          class="shoppingMain_priceAdd"
                          @click.stop="addNumber(index,indexSecond,indexThree)"
                        >
                          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/add.png" alt="add" />
                        </div>
                      </div>

                      <!-- 重选 -->
                      <div
                        class="shoppingMain_election"
                        v-if="itemThree.is_reelect != 0 && flgManagement == 1"
                        @click="shoppingStatusBtn(index,indexSecond,indexThree)"
                      >
                        <button>{{ chongxuan }}</button>
                      </div>

                      <div
                        class="shoppingMain_election"
                        v-if="itemThree.is_reelect != 0 && flgManagement == 2"
                        @click="shoppingStatusBtn(index,indexSecond,indexThree)"
                      >
                        <button>{{ chongxuan }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 限购数量 -->
                <div class="shoppingMain_buyNum">
                  <span v-if="itemThree.limit_info != undefined && itemThree.limit_info.length">
                    <span
                      v-for="(itemInfo,indexInfo) in itemThree.limit_info"
                      :key="indexInfo"
                    >{{itemInfo}}&nbsp;</span>
                  </span>
                  <!-- <span
                    v-if=" itemThree.restrict_num >0 "
                  >{{xiangou}}{{itemThree.restrict_num}}{{itemThree.pro_prounit}}</span>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 上拉加载更多 -->
        <!-- <div class="loadingMore">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/loading.png" alt="loading" />
          <span>上拉加载更多</span>
        </div>-->
      </div>

      <!-- 失效商品 -->
      <div class="shopping_ifNotEmpty" v-if="allFailureList.length && ifDate">
        <div class="shoppingCat_content" style=" margin-bottom:0; ">
          <div class="shoppingCat_contentTop">
            <!-- 失效商品 -->
            <div class="shoppingContent_status">
              <span>{{allFailureListName}}</span>
            </div>
            <!-- 一键清空 -->
            <div class="shoppingContent_quan" @click="emptyClick">
              <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/delete.png" alt="delete" />
              {{ yijianqingkong }}
            </div>
          </div>
          <!-- 下部购物车商品 -->
          <!-- 根据是否有满减的状态来显示border -->
          <div
            class="shoppingCat_main"
            style=" padding-left:0 "
            v-for="(item,index) in allFailureList"
            :key="index"
          >
            <!-- 商品 -->
            <div
              class="shoppingCat_mainBox"
              v-for="(itemFailShop,indexFailShop) in item.pro_list"
              :key="indexFailShop"
            >
              <!-- 满减,微团购 -->
              <div
                class="shoppingMain_bulkTime"
                v-if="itemFailShop.pro_type == 1 || itemFailShop.pro_type == 4"
                style=" margin-left:0 "
              >
                <!-- 满减 -->
                <div class="shoppingMain_bulk" style="margin-left:0">
                  <div
                    class="shoppingMain_bulkLeft"
                    style="background-color:#CCCCCC;margin-right:0.2rem"
                  >
                    <span>{{ itemFailShop.pro_tag }}</span>
                  </div>
                  <div class="shoppingMain_bulkReduction">
                    <span>{{ huodongyijieshu }}</span>
                  </div>
                  <div class="shoppingMain_bulkDetail">
                    <span></span>
                  </div>
                </div>
              </div>

              <div class="shoppingMain_BoxMain" style="width:100%;">
                <div class="shoppingMain_Box shoppingMain_BoxFailure">
                  <!-- 商品图片 -->
                  <div class="shoppingMain_picture">
                    <div class="shoppingMain_pictureBox">
                      <img :src="itemFailShop.pro_pic" alt="商品图片"  />
                      <!-- 已售罄 -->
                      <div class="shoppingMain_pictureOver" v-if=" itemFailShop.pro_stock <= 0 " @click.stop="goLinked(itemFailShop.pro_href)">
                        <span>{{ yishouqing}}</span>
                      </div>

                      <div class="shoppingMain_pictureOver" v-else @click.stop="goLinked(itemFailShop.pro_href)">
                        <!-- <span>{{ yishouqing}}</span> -->
                      </div>
                    </div>
                  </div>
                  <!-- 商品信息 -->
                  <div class="shoppingMain_information">
                    <div class="shoppingMain_informationTop">
                      <!-- 标题 -->
                      <div class="shoppingMain_title">
                        <span @click.stop="goLinked(itemFailShop.pro_href)">{{ itemFailShop.pro_name }}</span>
                      </div>
                    </div>
                    <!-- 价钱 -->
                    <div class="shoppingMain_price">
                      <div class="shoppingMain_priceBox">
                        <span>
                          <span class="smallText" v-html="currency_symbol"></span>
                          {{ itemFailShop.pro_price }}
                          <!-- <span class="smallText">.00</span> -->
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- 清除 -->
                  <div class="shoppingMain_clear" @click="clearShop(index,indexFailShop)">
                    <span>{{shanchu}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 没数据显示的内容 -->
      <div class="shopping_ifEmpty" v-if="!ifDate">
        <div>
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/empty.png" alt="empty" />
        </div>
        <div>
          <span>{{ gouwuchehaishikongde }}</span>
        </div>
        <div>
          <button @click="home_Link()">
            <a>{{ quguangguang }}</a>
          </button>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer" v-if="ifDate">
      <!-- 全选 -->
      <div class="footer_change">
        <!-- 单选框 -->
        <!-- 可选样式 -->
        <div
          :class=" shoppingContent_radioFlg ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
          @click.stop="checkAllRadio"
          v-if="(shoppingContent_radioFlg_no && flgManagement == 1) || flgManagement == 2 "
        >
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/check.png" alt="check" v-if="shoppingContent_radioFlg" />
        </div>

        <!-- 不可点击 -->
        <div
          class="shoppingContent_radio notInventory"
          v-if="!shoppingContent_radioFlg_no && flgManagement == 1"
        ></div>

        <span>{{ quanxuan }}</span>
      </div>

      <!-- 合计价钱 -->
      <div :class="flgSettlementBtn ? 'footer_price' :'hidden'" v-show=" flgManagement == 1 ">
        <div class="footer_allPrice">
          <span v-if="ifDate">
            {{ heji }}:
            <em>
              <span v-html="currency_symbol"></span>
              {{ total_price }}
            </em>
          </span>
        </div>
        <div class="footer_priceReduction" v-if="cut_money > 0">
          <span>{{man}}{{jian}}<span v-html="currency_symbol"></span>{{ cut_money }}</span>
        </div>
      </div>

      <!-- 去结算 -->
      <div class="footer_settlement">
        <!-- 有数据 -->
        <button
          :class=" flgSettlementBtn ? 'footer_settlementBtn' : 'hidden' "
          v-show=" flgManagement == 1 && ifDate && clickSettlement"
          @click="qujiesuanFun()"
        >{{ qujiesuan }}</button>
        <!-- 没选中数据 -->
        <button
          class="footer_settlementEmpty"
          v-show="!clickSettlement && flgManagement == 1"
        >{{ qujiesuan }}</button>

        <span v-show=" flgManagement == 2 ">{{ yixuan }}{{numFlg}}{{danweijian}}</span>
        <button
          class="footer_deleteBtn"
          v-show=" flgManagement == 2 "
          @click="deleteBtn"
        >{{shanchu}}</button>
      </div>
    </div>

    <!-- 点击关闭放大蒙版图片 -->
    <div class="amplification_box" v-if="imgFlg" @click="colseImg">
      <div class="amplification">
        <img :src="shopImgSrc " alt="商品图片" />
      </div>
    </div>

    <!-- 转盘弹窗 -->
    <CustomPopup ref="CustomVouchersRotary">
      <div slot="PoperContentMask" class="rotaryBox">
        <div class="shoppingCat_title">
          <!-- <span class="shoppingCat_back" @click="switchTo('/home')"></span> -->
          <span class="shoppingCat_text">{{ gouwuche }}</span>
        </div>
        <!-- 内容 -->
        <div class="rotaryContent">
          <span v-for="(item,index) in acvityList" :key="index" v-html="item"></span>
        </div>
        <div class="PoperRotaryBtn" @click="closeRotary">{{ shouqi }}</div>
      </div>
    </CustomPopup>

    <!-- 优惠券弹窗 -->
    <CustomPopup ref="CustomVouchers" @closeMask="closeVouchersBtn">
      <div
        slot="PoperContent"
        class="PoperContentView vouchersContentView"
        v-if="allCouponsListChange.length"
      >
        <div class="ServiceNoteTitle VouchersTitle W100">{{ title }}</div>
        <div style="height:6.19rem;overflow-y:scroll;overflow-x:hidden;">
          <div class="vouchersContentText" v-for="(item,index) in allCouponsListChange" :key="index">
            <!-- 优惠券 -->
            <div class="vouchersDetails">
              <div class="vouchersDetails_top">
                <div class="vouchersDetails_price">
                  <span>
                    <span class="vouchersDetails_symbol" v-html="currency_symbol"></span>
                    {{item.coupon_info.coupon_money}}
                  </span>
                  <span class="vouchersDetails_text">{{name}}</span>
                </div>
                <div class="vouchersDetails_rules">
                  <span>{{ use_rule }}：</span>
                  <span v-html="item.coupon_info.rule_info"></span>
                </div>
                <div class="vouchersDetails_btn" v-if=" zz_userid == 0 ">
                  <button class="vouchersDetailsBtn" @click="lingquFun()">{{ likelingqu }}</button>
                </div>
                <div class="vouchersDetails_btn" v-else>
                  <button
                    class="vouchersDetailsBtn"
                    v-if="item.coupon_info.receive == 0 && is_login == 1"
                    @click="receiveQuan(item.coupon_info.id,item.shop_id)"
                  >{{ likelingqu }}</button>
                  <button class="vouchersAlearyBtn" v-else>{{ yilingqu }}</button>
                </div>
              </div>

              <div class="vouchersDetails_bottom">
                <div v-if="item.coupon_info.receive_info != ''">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/warn.png" alt="“tip" />
                  <span>{{ item.coupon_info.receive_info }}</span>
                </div>
                <div>
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/time.png" alt="“tip" />
                  <span
                    class="bottomTime"
                  >{{ period_of_validity }}:{{ item.coupon_info.start_time.slice(0,11) }}{{ zhi }}{{ item.coupon_info.end_time.slice(0,11) }}</span>
                </div>
              </div>
            </div>
            <!-- 提示购物车可用商品 -->
            <div class="supportableGoods_box">
              <div class="supportableGoods_title">
                <span>{{ available_info }}</span>
              </div>
              <div class="supportableGoods">
                <div
                  class="supportableGoods_shopping"
                  v-for="(itemSecond,indexSecond) in item.coupon_info.pro_list"
                  :key="indexSecond"
                >
                  <div class="supportableGoods_shoppingImg">
                    <img :src="PrepicturesList[itemSecond].img_pic" alt="shop" />
                  </div>
                  <div class="supportableGoods_shoppingPrice">
                    <span v-html="currency_symbol"></span>
                    <span v-html="PrepicturesList[itemSecond].price"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="PoperContentBtn" @click="closeVouchersBtn">{{ wancheng }}</div>
      </div>
    </CustomPopup>

    <!-- 规格弹窗 -->
    <CustomPopup ref="shoppingStatus" @closeGuige="closeGuigeBtn">
      <div slot="PoperContent" class="PoperContentView shoppingStatusView">
        <!-- 顶部商品信息价格 -->
        <div class="shoppingStatus_top">
          <!-- 顶部商品图片 -->
          <div class="shoppingStatus_topImg" @click="openImg(guigeImg)">
            <img :src="guigeImg" alt="商品图片" />
          </div>

          <!-- 顶部规格 -->
          <div class="shoppingStatus_topStatus">
            <div class="shoppingStatus_topPrice">
              <div class="shoppingStatus_PriceBox">
                <!-- 原价 -->
                <span v-if="pro_original_price > 0 || pro_original_price != ''">
                  <span v-html="currency_symbol" style="font-size:0.28rem"></span>
                  <em>{{ pro_original_price }}</em>
                </span>
                <!-- 折扣价 -->
                <div
                  class="shoppingStatus_topReduction"
                  v-if="guige_pro_price != '' && pro_original_price != guige_pro_price"
                >
                  <!-- 原价为空 -->
                  <span
                    v-if="parseInt(pro_original_price) == 0 || pro_original_price == ''"
                    style="color: #F0250F !important;font-size: 0.34rem !important;"
                  >
                    <span v-html="currency_symbol"></span>
                    {{ guige_pro_price }}
                  </span>
                  <!-- 原价不为空 -->
                  <span v-else>
                    <span v-html="currency_symbol" style="color:#111"></span>
                    {{ guige_pro_price }}
                  </span>

                  <div class="status_thrid" v-if="guige_pro_tag!= ''">
                    <div
                      class="status_thrid_box"
                      v-if="guige_pro_tag == '会员价' || guige_pro_tag == '会员折扣'"
                    >
                      <span>{{ guige_pro_tag }}</span>
                    </div>
                    <div class="status_thrid_box2" v-else>
                      <span>{{ guige_pro_tag }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <span
                v-if="jifen_must_num > 0"
              >{{ bixushiyong }}{{ jifen_must_num }}{{ guige_xf_name }}</span>
            </div>
            <div v-if="guigeName != undefined || guigeName!= '' || guigeName!= null">
              <span>
                {{ yixuan }}：
                <em
                  v-for="(itemName,indexName) in guigeName"
                  :key="indexName"
                >{{ '"' + itemName+ '"'}}&nbsp;&nbsp;</em>
              </span>
            </div>
          </div>

          <!-- 关闭按钮 -->
          <div class="shoppingStatus_colseBtn" @click="closeGuigeBtn">
            <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/close.png" alt="关闭" />
          </div>
        </div>

        <!-- 下部规格部分 -->
        <div class="shoppingStatus_infos">
          <!-- 未选手机号 -->
          <div class="shoppingStatus_Nophone" v-show=" false ">
            <span>请先选择手机号</span>
            <button>立即选号</button>
          </div>
          <!-- 已选手机号 -->
          <div class="shoppingStatus_Yesphone" v-show=" false ">
            <span>已选手机号</span>
            <div class="shoppingStatus_changePhone">
              <span class="shoppingStatus_Phone">13602096703</span>
              <em>更换</em>
            </div>
          </div>

          <!-- 规格展示的数据 -->
          <div class="shoppingStatus_infosBox" v-if="spec_info.length">
            <div
              :class=" spec_info.length >1 && wholesale_info.length>1  ?  'shoppingStatus_colorSize' : ''"
            >
              <div class="shoppingStatus_infosColor" v-for="(item,index) in spec_info" :key="index">
                <div class="shoppingStatus_colorTitle">
                  <span>{{item.name}}</span>
                </div>
                <div class="shoppingStatus_colorValue">
                  <span
                    :class="itemSecond.is_default == 1 ? 'activeColor' : ''"
                    @click=" changColorClick(index,indexSecond)"
                    v-for="(itemSecond,indexSecond) in item.spec"
                    :key="indexSecond"
                  >{{ itemSecond.name }}</span>
                </div>
              </div>

              <!-- 尺码 -->
              <!-- <div class="shoppingStatus_infosSize">
                <div class="shoppingStatus_infosColor">
                  <div class="shoppingStatus_colorTitle">
                    <span>尺码</span>
                  </div>
                  <div class="shoppingStatus_colorValue">
                    <span
                      :class="(item.active == 1) ? 'activeColor' : '' "
                      @click=" changSizeClick(item.id) "
                      v-for="item in sizeList"
                      :key="item.id"
                    >{{ item.colorValue }}</span>
                  </div>
                </div>
              </div>-->
            </div>

            <!-- 购买数量 -->
            <!-- <div class="shoppingStatus_infosNumbers">
              <em>购买数量</em>
              <div class="shoppingStatus_numbersChange">
                <span>最多选择200件</span>
                <div class="shoppingStatus_numbersChangeBox">
                  <span class="reduce" @click="reduceBuyNumbers">—</span>
                  <input type="number" v-model="changeNumbers" />
                  <span class="add" @click="addBuyNumbers">+</span>
                </div>
              </div>
            </div>-->
            <!-- 批发商品 -->
            <div class="shoppingStatus_infosWholesale" v-if="wholesale_info.length">
              <span>{{pifa}}</span>
              <div class="shoppingStatus_wholesaleBox">
                <span v-for="(itemShop,indexShop) in wholesale_info" :key="indexShop">
                  <em v-if="indexShop == 0">
                    {{ guige_man }}{{itemShop.split('_')[0]}}{{meijian}}
                    <span
                      style="padding:0"
                      v-html="currency_symbol"
                    ></span>{{itemShop.split('_')[1]}}/{{meijian}}
                  </em>
                  <em v-else>
                    {{ guige_man }}{{parseInt(itemShop.split('_')[0]) + 1}}{{meijian}}
                    <span
                      style="padding:0"
                      v-html="currency_symbol"
                    ></span>{{itemShop.split('_')[1]}}/{{meijian}}
                  </em>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="shoppingNoPopup vouchersContentBtn">立即购买</div> -->
        <!-- <div class="shoppingChangeBtn vouchersContentBtn">
          <button>立即购买</button>
          <button @click="joinCat()">加入购物车</button>
        </div>-->

        <div
          class="shoppingStatusPopup"
          @click="querenClick()"
          v-if="guige_isBuy == 1"
        >{{queren}}</div>
      <div class="shoppingStatusPopupNot" v-if="guige_isBuy == 0">{{err_msg}}</div>
      </div>
      
    </CustomPopup>

    <!-- 输入购买数量弹出框 -->
    <Bounced ref="writeNumberInfo">
      <div slot="bouncedContent">
        <div class="bouncedContent_number">
          <div class="bouncedContent_numberTitle">
            <span>{{ qingshurugoumaishuliang }}</span>
          </div>
          <div class="bouncedContent_changeNumber">
            <img
              class="changeNumber_reduce"
              v-if="fillInText > 1"
              src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceYes.png"
              alt="减少"
              @click.stop="fillInReduce"
            />
            <img
              class="changeNumber_reduce"
              v-else
              src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceNo.png"
              alt="减少"
              @click.stop="fillInReduce"
            />
            <input
              type="number"
              v-model="fillInText"
              v-on:input="numberInput"
              @blur.stop="changFillText()"
            />
            <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/add.png" alt="增加" @click.stop="fillInAdd" />
          </div>
        </div>
        <!-- 底部取消取消,确认按钮 -->
        <div class="customPopupContent_button">
          <button @click.stop="cancelNumBtn">{{ quxiao }}</button>
          <button @click.stop="confirmNumBtn">{{queren}}</button>
        </div>
      </div>
    </Bounced>

    <!-- 删除信息弹出框 -->
    <Bounced ref="numbersInfo">
      <div slot="bouncedContent">
        <div class="bouncedContent_text">
          <span v-if="deleteInfo == 1">{{quedingyaoshanchucishangpinma}}</span>
          <span v-else-if="deleteInfo == 2 || deleteInfo == 3">{{quedingyaoshanchuxuanzhongshangpinma}}</span>
        </div>
        <!-- 底部取消取消,确认按钮 -->
        <div class="customPopupContent_button">
          <button @click="cancelBtn">{{ quxiao }}</button>
          <button @click="confirmBtn">{{ queren }}</button>
        </div>
      </div>
    </Bounced>

    <!-- 满减,限时购,弹窗 -->
    <CustomPopup ref="CustomTimeLimit" @closeManjian="closeTimeLimitBtn">
      <div slot="PoperContent" class="PoperContentView manjianXsg">
        <div class="ServiceTimeLimit W100">
          <div class="timeLimit_reduce" v-if="fullRedName!= ''">
            <span>{{ fullRedName }}</span>
          </div>
          <div class="timeLimit_name" v-if="fullRedTitle!= ''">
            <span>{{ fullRedTitle }}</span>
          </div>

          <!-- <div class="timeLimit_name" v-if="fullRedTitle!= '' && xinashigouType == 4" >
            <span>{{ active_text }}</span>
          </div>-->

          <div class="timeLimit_more" v-if="gengduokeyongshangpin && xinashigouType == 2">
            <a :href="rule_href"><span>{{gengduokeyongshangpin}}</span></a>
            
            <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="right" />
          </div>
        </div>
        <!-- 金额满减 -->
        <div class="TipContentText2" v-if="fullRedInfo.length>0 && xinashigouType == 2">
          <span v-for="(item,index) in fullRedInfo" :key="index" v-html="item"></span>
        </div>
        <!-- 活动时间 -->
        <!-- 满减 -->
        <div class="TipContentTime" v-if="activityTimes!= '' && xinashigouType == 2">
          <span>{{huodongshijian}}</span>
          <span>{{ activityTimes }}</span>
        </div>
        <!-- 限时购 -->
        <div
          class="TipContentTime"
          v-if="xsgEnd_time!= '' &&( xinashigouType == 4 || xinashigouType == 1)"
        >
          <span>{{huodongshijian}}</span>
          <span>{{xsgStar_time}} {{ zhi }} {{ xsgEnd_time }}</span>
        </div>

        <div class="PoperContentBtn" @click="closeTimeLimitBtn">{{wancheng}}</div>
      </div>
    </CustomPopup>

    <!-- 批发弹窗 -->
    <CustomPopup ref="CustomWholesale" @closePifa="closewholesaleBtn">
      <div slot="PoperContent" class="PoperContentView">
        <div class="wholesaleTimeLimit W100" style="border-bottom:0">
          <!-- <div>
            <div class="timeLimit_reduce">
              <span>批发</span>
            </div>
            <div class="timeLimit_name">
              <span>促销名称促销名称促销名称促销名称促销名称促销名称促销名称促销名称促销名称促销名称</span>
            </div>
          </div>-->
          <div class="wholesaleHuige" v-if="flgWholesaleHuige">
            <span>
              <span class="wholesaleAleady">{{yixuan}}：</span>
              <span v-html="flgWholesaleHuigeValue"></span>
            </span>
          </div>
        </div>
        <!-- 金额满减 -->
        <div class="wholesaleContentText">
          <div v-for="(item,index) in rule_alert_Array" :key="index">
            <span>
              <span class="wholesaleContentText_buynum" v-html="item.b"></span>
            </span>
            <span v-html="item.m"></span>
          </div>
        </div>
        <div class="PoperContentBtn" @click="closewholesaleBtn">{{wancheng}}</div>
      </div>
    </CustomPopup>
  </div>
</template>

<script>
// 引入底部弹出框
import CustomPopup from "../../components/CustomPopup/custompopup.vue";

// 引入删除信息,增加商品弹出框
import Bounced from "../../components/Bounced/bounced.vue";

// 引入购物车列表接口
// import {shoppingList} from "../../api/indexPost"

// import axios from 'axios'

export default {
  name: "ShoppingCat",
  // 弹窗组件
  components: {
    CustomPopup,
    Bounced
  },
  data() {
    return {
      // 颜色
      theme:'#fe0000',
      // 动态改变购物车title,
      pageTitle:'',
      // 判断购物车是否有数据
      all_data: true,
      // username: this.$route.query.username,
      // 顶部满金额获得转盘抽奖,默认不显示
      rotaryTableFlg: true,
      // 底部边框,有满减或微团购显示,默认不显示
      flgShoppingMain: false,
      // 总的单选按钮,默认不选中
      shoppingContent_radioFlg: true,
      // 单个单选按钮
      itemActive: -1,

      //   定义购物车商品数据
      shopCatList: [],
      // 满减,活动
      shopCatActivityList: [],

      // 失效shangpin
      shopCatFailureList: [],
      // 管理和完成状态的切换,默认管理
      flgManagement: 1,
      // 去结算在有数据和没数据的样式切换
      flgSettlementBtn: true,
      // 判断是否有数据,true为有数据
      ifDate: true,
      // 页面用户输入商品数量
      numbers: 1,
      // 弹出框用户输入商品数量
      fillInText: 1,
      // 数量减少图片切换,为1时不能再减少
      changMumImg: "https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceYes.png",

      // 颜色值
      colorList: [
        {
          id: 0,
          colorValue: "绿",
          active: 0
        },
        {
          id: 1,
          colorValue: "比较长的军绿色",
          active: 0
        },
        {
          id: 2,
          colorValue: "红",
          active: 0
        },
        {
          id: 3,
          colorValue: "黑",
          active: 0
        },
        {
          id: 4,
          colorValue: "紫色",
          active: 0
        },
        {
          id: 5,
          colorValue: "勃艮第红",
          active: 1,
          defaultColor: "勃艮第红"
        }
      ],
      // 尺码值
      sizeList: [
        {
          id: 0,
          colorValue: "M",
          active: 1,
          defaultSize: "M"
        },
        {
          id: 1,
          colorValue: "L",
          active: 0
        },
        {
          id: 2,
          colorValue: "XL",
          active: 0
        },
        {
          id: 3,
          colorValue: "XXL",
          active: 0
        },
        {
          id: 4,
          colorValue: "XXXL",
          active: 0
        },
        {
          id: 5,
          colorValue: "XXXXL",
          active: 0
        }
      ],
      // color颜色是否被选中,默认不被选中
      flgColor: false,
      // 规格弹窗购买数量
      changeNumbers: 1,
      // 失效商品显示和隐藏
      failureShop: true,
      // 定义变量,用来存储数组的index
      indexShoping: -1,
      // 弹出框的颜色值
      bouncedColor: "",
      // 弹出框尺码值
      bouncedSIze: "",
      // 弹出框购买数量
      bouncedNumber: "",
      // 删除信息弹出框
      allNumbers: "",
      // 定义一个变量,用来判断,用户是否点击了规格弹窗中的立即购买
      buyNow: 0,
      // 定义一个变量,用来判断删除弹框是通过点击减号(1)、清空(2)还是删除按钮(3)
      deleteConditions: -1,

      // 删除信息(1:删除单个商品,2:删除多个商品)
      deleteInfo: 1,
      // 定义个numinterface用来判断接口是否在请求,请求成功之后让其加一
      numInterface: 0,
      // 失效商品显示
      ifFailureDate: false,
      // 失效商品名称
      allFailureListName: "",
      // 总金额
      total_price: 0,
      // 满减金额
      cut_money: 0,
      // 必须使用
      bixushiyong: "",
      // 页面标题
      gouwuche: "",
      //购物车还是空的
      gouwuchehaishikongde: "",
      // 活动已结束
      huodongyijieshu: "",
      // 减
      jian: "",
      // 据活动结束还剩
      juhuodongjieshuhaisheng: "",
      // 满
      man: "",
      // 全选
      quanxuan: "",
      // 去逛逛
      quguangguang: "",
      // 删除
      shanchu: "",
      // 完成
      wancheng: "",
      // 消费积分重命名
      xf_name: "",
      // 详情
      xiangqing: "",
      // 一键清空
      yijianqingkong: "",
      // 已选
      yixuan: "",
      // 自营
      ziying: "",
      // 商品数组
      allPrudctList: [],
      // 失效商品数组
      allFailureList: [],
      // 重选
      chongxuan: "",
      // 合计
      heji: "",
      // 收起
      shouqi: "",
      // 请输入购买数量
      qingshurugoumaishuliang: "",
      // 确定要删除此商品吗?
      quedingyaoshanchucishangpinma: "",
      // 确定要删除选中商品吗?
      quedingyaoshanchuxuanzhongshangpinma: "",
      // 去结算
      qujiesuan: "",
      // 微团购
      weituangou: "",
      // 限时购
      xianshigou: "",
      // 已售罄
      yishouqing: "",
      // 已满减
      yimanjian: "",
      // 已选
      yixuan: "",
      // 确认
      queren: "",
      // 取消
      quxiao: "",
      // 去逛逛点击之后的链接
      home_url: "",
      // 更多可用商品
      gengduokeyongshangpin: "",
      // 活动时间
      huodongshijian: "",
      // 限购
      xiangou: "",
      // 购买超过库存
      goumaichaoguokucun: "",
      // 购买超过限购
      goumaichaoguoxiangou: "",
      // 起售
      qishou: "",

      // 一级索引
      index: 0,
      // 二级索引
      indexSecond: 0,
      // 三级索引
      indexThree: 0,

      // 优惠券数组
      allCouponsList: [],
      // 优惠券弹窗(为了在页面刚渲染的时候给数组赋值)
      allCouponsListChange: [],
      // 优惠券数组(转接,点击遮罩层关闭的时候,重写给优惠券弹窗赋值)
      allCouponsList2: [],
      // 传入优惠券的参数
      idsFlg: -1,
      // 自定义数组,存储图片路径和id
      PrepicturesList: [],
      // name
      name: "",
      // 代金券
      daijinquan: "",
      // 是否登录,0未登录,1登录
      is_login: 0,
      // title
      title: "",
      // 立即领取
      likelingqu: "",
      // 已领取
      yilingqu: "",
      // 使用规则
      use_rule: "",
      // 购物车内以下商品可用
      available_info: "",
      // 有效期
      period_of_validity: "",
      // 至
      zhi: "",
      // 活动截止至
      huodongjiezhizhi: "",
      // 定一个变量,用来存储批发的总数量
      totalNumber: 0,
      // 管理
      guanli: "",
      // 未到达最小起售数量
      weidadaozuixiaoqishoushuliang: "",
      // 件
      danweijian: "",

      // 活动信息接口列表数据
      acvityList: [],

      // 满减弹窗
      fullRedName: "",
      // 标题
      fullRedTitle: "",
      // 满减信息
      fullRedInfo: [],
      // 活动时间
      fullRedTime: "",
      // 活动时间
      activityTimes: "",

      // 批发弹窗
      wholesaleName: "",
      // 标题
      wholesaleTitle: "",

      // 批发弹窗,已选规格,默认隐藏
      flgWholesaleHuige: false,
      // 内容
      flgWholesaleHuigeValue: "",
      // 数组
      rule_alert_Array: [],

      // 选中的单选按钮的数组
      ids: [],

      // 定义一个参数用来判断弹出框输入数量和限购数量做判断
      ifJudge: true,

      // 规格弹窗数据
      guigeList: [],
      // 规格1
      guige1: "",
      // 规格2
      // guige2:'',
      // 规格数据
      spec_info: [],
      // 满减数据
      wholesale_info: [],
      // 满减文字
      pifa: "",
      // 图片路径
      guigeImg: "",
      // 已选
      yixuan: "",
      // 必须使用
      bixushiyong: "",
      // jifen_must_num大于0,则必须使用
      jifen_must_num: "",
      // 必须使用的规格
      guige_xf_name: "",
      // 满
      guige_man: "",
      // 件
      meijian: "",
      // 批发
      guige_pro_tag: "",
      // 规格name
      guige_name: "",
      // 已选规格
      guigeName: "",
      // 优惠金额
      guige_pro_price: "",
      // 金额
      pro_original_price: "",
      // 优惠券点击之后临时存起来的id
      vouchersTemOId: -1,
      // 金钱符号
      currency_symbol: "",
      // 拼接的params_id的值
      yixuanValue: [],
      // pro_spec的数据
      pro_specList: [],
      // 是否能购买
      guige_isBuy: -1,
      // 把规格弹窗的pro_id和param_id取出来
      guige_pro_id: "",
      guige_param_id: "",
      // 点击商铺存入param_id
      guige_BeforeParam: "",
      // 规格弹窗点击确认需要传入接口的num
      guige_num: "",
      // 限时购(1)和微团购(4)对应数字
      xinashigouType: -1,
      // 限时购开始活动时间
      xsgStar_time: "",
      // 限时购结束活动时间
      xsgEnd_time: "",

      // zz_userid用来判断用户是否登录
      zz_userid: 0,

      // flgGuigeValue用来判断管理状态下是不是改变了规格,
      flgGuigeValue: 0,

      // 删除成功一个状态
      flgDeleted: 0,
      // 定义一个参数,判断,规格接口信息时候调取完成
      flgGuigeInfo: false,

      // 判断跳转上一页还是返回首页
      return_type: 1,
      // 首页链接
      home_url: "",
      // 登录页链接
      self_href: "",

      // 判断去结算是否可点击
      clickSettlement: true,

      // 点击放大的商品图片路径
      shopImgSrc: "",
      // 判断点击是否放大图片,默认不放大
      imgFlg: false,

      // 用于判断底部是否可选
      shoppingContent_radioFlg_no: false,
      // 数据
      allTextdata:'',
      // 判断已选多少件
      numFlg:0,
      // 更多可用商品
      moreShopHref:'',

      // 更多可用商品链接
      rule_href:'',
      // 不能购买的错误信息
      err_msg:'',

      // 定义变量,用来判断倒计时是否需要加载
      pro_type_value:0
    };
  },
  methods: {
    // 规格弹窗函数封装
    specificationsFun(pro_id, param_id) {
      //加载层-默认风格
      layui.use("layer", function() {
        layer.ready(function() {
          layer.load({
            shade: false
          });
        });
      });

      let that = this;
      that.$F.Response({
        url: "mallorder/api/specinfo.php",
        param: { username: that.$route.query.username, pro_id: pro_id },
        success: allData => {
          if (allData.code == 200) {
            that.flgGuigeInfo = true;
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });

            // 弹窗显示
            if (this.flgGuigeInfo == true) {
              that.$refs.shoppingStatus.showCustom();
            }

            let guigeValue = [];
            guigeValue.push(allData);
            that.guigeList = guigeValue;
            // 当图片路径为空时,图片路径
            that.guigeImg = allData.pro_pic;
            // 规格数据
            that.spec_info = allData.spec_info;
            // 满减数据
            that.wholesale_info = allData.wholesale_info;
            // 满减文字
            that.pifa = allData.laguage_info.pifa;
            // 已选
            that.yixuan = allData.laguage_info.yixuan;
            // 必须使用
            that.bixushiyong = allData.laguage_info.bixushiyong;
            // 必须使用判断条件
            that.jifen_must_num = allData.jifen_must_num;
            // 必须使用的规格
            that.guige_xf_name = allData.xf_name;
            // 每件
            that.meijian = allData.laguage_info.meijian;
            // 满
            that.guige_man = allData.laguage_info.man;
            // // 金钱符号
            // that.currency_symbol = allData.currency_symbol;
            // 取出proid
            that.guige_pro_id = allData.pro_id;

            // 组合数据
            let pro_specValue = allData.pro_spec[param_id];
            // 取值的总数据
            that.pro_specList = allData.pro_spec;

            

            // 判断组合数据是不是为undefined,防止paramid传错的情况出现,或者重选情况
            if (pro_specValue != undefined) {
              let spec_info = allData.spec_info;

              if (spec_info.length > 0) {
                for (let j = 0; j < spec_info.length; j++) {
                  for (let k = 0; k < spec_info[j].spec.length; k++) {
                    // 先判断是否有默认规格,如果没有默认选择接口返回的规格
                    if (JSON.stringify(that.guigeList[0].pro_spec) != "{}") {
                      if (
                        that.guigeList[0].spec_info[j].spec[
                          k
                        ].param_ids.indexOf(param_id) != -1
                      ) {
                        that.guigeList[0].spec_info[j].spec[k].is_default = 1;
                      } else {
                        that.guigeList[0].spec_info[j].spec[k].is_default = 0;
                      }
                      that.spec_info = that.guigeList[0].spec_info;
                    } else {
                      that.spec_info = that.guigeList[0].spec_info;
                    }
                  }
                }
              } else {
                //请求购物车列表接口
                that.againRequest();
              }

              // 已选规格
              if (pro_specValue.name != undefined) {
                that.guigeName = pro_specValue.name.split("#");
              }
              // 优惠价
              that.guige_pro_price = pro_specValue.pro_price_show;
              // 原价
              that.pro_original_price = pro_specValue.pro_original_price_show;
              // 优惠方式
              that.guige_pro_tag = pro_specValue.pro_tag;
              // 是否能购买
              that.guige_isBuy = pro_specValue.is_buy;
              if(that.guige_isBuy == 0){
              that.err_msg = pro_specValue.err_msg
            }
              // 满减数据
              that.wholesale_info = pro_specValue.wholesale_info;
              // 必须使用判断条件
              that.jifen_must_num = pro_specValue.jifen_must_num;
              // 图片
              if (pro_specValue.pro_pic != "") {
                that.guigeImg = pro_specValue.pro_pic;
              } else {
                if (allData.pro_pic != "") {
                  that.guigeImg = allData.pro_pic;
                } else {
                  that.guigeImg = allData.pro_nopic;
                }
              }
            } else {
              let yixuanValueLast = [];
              // 这个循环取出选中的值
              for (let i = 0; i < that.spec_info.length; i++) {
                for (let j = 0; j < that.spec_info[i].spec.length; j++) {
                  if (that.spec_info[i].spec[j].is_default == "1") {
                    yixuanValueLast = yixuanValueLast.concat(
                      that.spec_info[i].spec[j].param_ids
                    );
                  }
                }
              }
              // 输出重复项
              let repeat = "";
              if (yixuanValueLast.length > 1) {
                var nary = yixuanValueLast.sort();
                for (var i = 0; i < nary.length; i++) {
                  if (nary[i] == nary[i + 1]) {
                    repeat = nary[i];
                  }
                }
              } else {
                repeat = yixuanValueLast[0];
              }

              // 取出对应pro_spec的值,
              let guigeLastValue = that.pro_specList[repeat];

              // 优惠价
              that.pro_price = guigeLastValue.pro_price_show;
              // 原价
              that.pro_original_price = guigeLastValue.pro_original_price_show;
              // 批发
              that.guige_pro_tag = guigeLastValue.pro_tag;
              // 规格名称
              that.guigeName = guigeLastValue.name.split("#");
              // is_buy
              that.guige_isBuy = guigeLastValue.is_buy;
              if(that.guige_isBuy == 0){
                that.err_msg = guigeLastValue.err_msg
              }
              // 批发数据
              that.wholesale_info = guigeLastValue.wholesale_info;
              // 优惠金额
              that.guige_pro_price = guigeLastValue.pro_price_show;
              // 必须使用判断条件
              that.jifen_must_num = guigeLastValue.jifen_must_num;

              // 图片
              if (guigeLastValue.pro_pic != "") {
                that.guigeImg = guigeLastValue.pro_pic;
                return;
              }
              if (that.guigeList[0].pro_pic != "") {
                that.guigeImg = that.guigeList[0].pro_pic;
                return;
              }
              that.guigeImg = that.guigeList[0].pro_nopic;
            }
          } else if (allData.code != 200) {
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(allData.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
        },
        error: () => {
          let that = this
          setTimeout(function() {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }, 300);

          // //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   });
          // });
        }
      });
    },

    // 分类选择
    changColorClick(index, indexSecond) {
      let that = this;
      // let yixuanValueLast = that.yixuanValue;
      let yixuanValueLast = [];
      // 这个循环改变选中的状态值
      for (let j = 0; j < that.spec_info[index].spec.length; j++) {
        if (indexSecond == j) {
          that.spec_info[index].spec[j].is_default = 1;
        } else {
          that.spec_info[index].spec[j].is_default = 0;
        }
      }
      // 这个循环取出选中的值
      for (let i = 0; i < that.spec_info.length; i++) {
        for (let j = 0; j < that.spec_info[i].spec.length; j++) {
          if (that.spec_info[i].spec[j].is_default == 1) {
            yixuanValueLast = yixuanValueLast.concat(
              that.spec_info[i].spec[j].param_ids
            );
          }
        }
      }

      // 输出重复项
      let repeat = "";
      if (yixuanValueLast.length > 1) {
        var nary = yixuanValueLast.sort();
        for (var i = 0; i < nary.length; i++) {
          if (nary[i] == nary[i + 1]) {
            repeat = nary[i];
          }
        }
      } else {
        repeat = yixuanValueLast[0];
      }

      // 取出对应pro_spec的值,
      let guigeLastValue = that.pro_specList[repeat];
      // 取出param_id
      that.guige_param_id = repeat;

      // 批发数据
      that.wholesale_info = guigeLastValue.wholesale_info;
      // 优惠价
      that.pro_price = guigeLastValue.pro_price_show;
      // 原价
      that.pro_original_price = guigeLastValue.pro_original_price_show;

      // 批发
      that.guige_pro_tag = guigeLastValue.pro_tag;
      // 规格名称
      that.guigeName = guigeLastValue.name.split("#");
      // is_buy
      that.guige_isBuy = guigeLastValue.is_buy;

       if(that.guige_isBuy == 0){
                that.err_msg = guigeLastValue.err_msg
              }

      // 优惠金额
      that.guige_pro_price = guigeLastValue.pro_price_show;
      // 必须使用判断条件
      that.jifen_must_num = guigeLastValue.jifen_must_num;
      // 图片
      if (guigeLastValue.pro_pic != "") {
        that.guigeImg = guigeLastValue.pro_pic;
        return;
      }
      if (that.guigeList[0].pro_pic != "") {
        that.guigeImg = that.guigeList[0].pro_pic;
        return;
      }
      that.guigeImg = that.guigeList[0].pro_nopic;
    },

    // 规格选项
    shoppingStatusBtn(index, indexSecond, indexThree) {
      let that = this;

      that.index = index;
      that.indexSecond = indexSecond;
      that.indexThree = indexThree;

      let pro_id =
        that.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
          .pro_id;
      let param_id =
        that.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
          .param_id;

      that.guige_num =
        that.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].pro_num;

      that.guige_BeforeParam =
        that.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].param_id;

      that.guige_BeforePro =
        that.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].pro_id;

      that.specificationsFun(pro_id, param_id);
      // that.indexShoping = index;
    },

    // 规格弹窗点击确认
    querenClick() {
      this.closeGuigeBtn();
      let that = this;
      let cartKey = this.$route.query.username + "_gouwuche",
        cart = this.$cookies.get(cartKey);

      let id = this.guige_pro_id;
      if(this.guige_param_id == ''){
        this.guige_param_id = this.guige_BeforeParam
      }
      let param_id = this.guige_param_id;
      let key = id + "_" + param_id;

      let before_id = this.guige_BeforePro;
      let before_paramId = this.guige_BeforeParam;
      let before_key = before_id + "_" + before_paramId;
      var new_cart = {};

      let idsList = [];
      if(that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[that.indexThree].is_check==0 || that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[that.indexThree].is_check==1){
        that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[that.indexThree].is_check=1
      }
      // 选中的单选按钮数组
      for (let i = 0; i < that.allPrudctList.length; i++) {
        for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
          for (
            let k = 0;
            k < that.allPrudctList[i].shop_info[j].pro_list.length;
            k++
          ) {
            if (that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1 && k!= that.indexThree) {
              let idAll =
                that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                "_" +
                that.allPrudctList[i].shop_info[j].pro_list[k].param_id;
              idsList.push(idAll);
            }
          }
        }
      }
      idsList.push(key)

      this.ids = idsList;
      // 用来判断登录状态不需要走下面的请求接口
      let value = 1;
      if (parseInt(this.zz_userid)) {
        this.changDates(before_key, key, this.guige_num);
        value = 2;
      } else {
        value = 1;
        if (cart) {
          // 用来判断是否需要将新规格加入 
        let is_have = 0;
        if(before_key == key){
          value = 2
        }else{
          for (let i in cart) {
            if (key == i) {
              is_have = 1
            } 
          }
          if (is_have) {
            for(let j in cart) {
              if (before_key != j) {
                  if (key == j) {
                    let numValue =  parseInt(cart[key].num) + parseInt(this.guige_num)
                    new_cart[key] = {num:numValue};
                  } else {
                    new_cart[j] = cart[j];
                  }
                }
            }
            
          }else {
            for(let k in cart) {
                if (before_key == k) {
                  new_cart[key] = { num: this.guige_num };
                } else {
                  new_cart[k] = cart[k];
                }
            }
        }

          }
          // 存入cookie
          if (new_cart) {
            this.$cookies.set(
              this.$route.query.username + "_gouwuche",
              JSON.stringify(new_cart),
              3600 * 7
            );
          }
        }
      }
      
      if(value == 1){
        // 调用购物车列表接口
        this.againRequest();
      }
    },

    // 关闭规格
    closeGuigeBtn() {
      this.$refs.shoppingStatus.maskClickHidden();
      this.allCouponsList = this.allCouponsList2;
      this.guigeList = [];
      // 让拼接的已选规格为空
      this.guige1 = "";
    },

    // 跳转方法
    switchTo(path) {
      //$router中的path是当前的路由路径
      this.$router.replace(path);
    },
    // 全选
    checkAllRadio() {
      let that = this;

      if (that.flgManagement == 1) {
        let idsList = [];
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if (that.shoppingContent_radioFlg == false && that.allPrudctList[i].shop_info[j].pro_list[k].is_buy != 0) {

                let idAll =
                  that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                  "_" +
                  that.allPrudctList[i].shop_info[j].pro_list[k].param_id;
                idsList.push(idAll);
                // that.shoppingContent_radioFlg = true;
              } else if (that.shoppingContent_radioFlg == true) {
                idsList = [];
              }
            }
          }
        }
        // 将选中的单选按钮存到data中
        that.ids = idsList;
        this.againRequest();
      } else {
        let numFlg = 0;
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              numFlg++
              if (that.shoppingContent_radioFlg == false) {
                that.allPrudctList[i].shop_info[j].pro_list[k].is_check = 1;
                that.allPrudctList[i].ifShow = 1;

              } else if (that.shoppingContent_radioFlg == true) {
                that.allPrudctList[i].shop_info[j].pro_list[k].is_check = 0;
                that.allPrudctList[i].ifShow = 0;
              }
            }
          }
        }
        if (that.shoppingContent_radioFlg == false) {
          that.shoppingContent_radioFlg = true;
          // 选中的件数
          that.numFlg =numFlg
        } else if (that.shoppingContent_radioFlg == true) {
          that.shoppingContent_radioFlg = false;
          // 选中的件数
        that.numFlg =0
        }
        
      }
    },

    //  商铺下的所有单选框选中
    checkRadio(index) {
      let that = this;
      let shopCatList = JSON.parse(
        JSON.stringify(that.allPrudctList[index].shop_info)
      );
      if (that.allPrudctList[index].ifShow == 0) {
        that.allPrudctList[index].ifShow = 1;
      } else if (that.allPrudctList[index].ifShow == 1) {
        that.allPrudctList[index].ifShow = 0;
      }

      // 选中全部radio
      for (let j = 0; j < shopCatList.length; j++) {
        for (let k = 0; k < shopCatList[j].pro_list.length; k++) {
          shopCatList[j].pro_list[k].is_check =
            that.allPrudctList[index].ifShow;
        }
      }
      that.allPrudctList[index].shop_info = shopCatList;
      // 管理下的状态
      if (that.flgManagement == 1) {
        // 选中的单选按钮数组
        let idsList = [];
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if (
                that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1
              ) {
                let idAll =
                  that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                  "_" +
                  that.allPrudctList[i].shop_info[j].pro_list[k].param_id;
                idsList.push(idAll);
              }
            }
          }
        }
        // 将选中的单选按钮存到data中
        that.ids = idsList;

        this.againRequest();
      } else {
        // 选中的数量
        let numFlg = 0;
        // 变量
        let dataFlg = 0;
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if (
                that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1
              ) {
                numFlg++;
              }

              if(that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 0){
                dataFlg = 1
              }
            }
          }
        }
        that.numFlg = numFlg;
        // 判断全选的状态
        if(dataFlg){
          that.shoppingContent_radioFlg = false;
        }else{
          that.shoppingContent_radioFlg = true;
        }
      }
    },
    // 单个单选框选中
    selectedCurrentRadio(index, indexSecond, indexThree, type) {
      let that = this;
      
      if (that.flgManagement == 1) {
        // 批发组的单选按钮
        if (type == 1) {
          let buyResult =
            that.allPrudctList[index].shop_info[indexSecond].pro_list;
          let is_buyResult =
            that.allPrudctList[index].shop_info[indexSecond].pro_list[
              indexThree
            ].is_check;
          if (is_buyResult == 0) {
            for (var i = 0; i < buyResult.length; i++) {
              that.allPrudctList[index].shop_info[indexSecond].pro_list[
                i
              ].is_check = 1;
            }
          } else if (is_buyResult == 1) {
            for (var i = 0; i < buyResult.length; i++) {
              that.allPrudctList[index].shop_info[indexSecond].pro_list[
                i
              ].is_check = 0;
            }
          }
        } else if (type == 2) {
          //非批发组的单选按钮
          let buyResult =
            that.allPrudctList[index].shop_info[indexSecond].pro_list;
          let is_buyResult =
            that.allPrudctList[index].shop_info[indexSecond].pro_list[
              indexThree
            ].is_check;

          if (is_buyResult == 0) {
            that.allPrudctList[index].shop_info[indexSecond].pro_list[
              indexThree
            ].is_check = 1;
          } else if (is_buyResult == 1) {
            that.allPrudctList[index].shop_info[indexSecond].pro_list[
              indexThree
            ].is_check = 0;
          }
        }
        // 选中的单选按钮数组
        let idsList = [];
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if (
                that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1
              ) {
                let idAll =
                  that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                  "_" +
                  that.allPrudctList[i].shop_info[j].pro_list[k].param_id;
                idsList.push(idAll);
              }
            }
          }
        }
        // 将选中的单选按钮存到data中
        that.ids = idsList;
        this.againRequest();
      } else {
        if (
          that.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
            .is_check == 1
        ) {
          that.allPrudctList[index].shop_info[indexSecond].pro_list[
            indexThree
          ].is_check = 0;

          that.total_num =
            parseInt(that.total_num) -
            parseInt(
              that.allPrudctList[index].shop_info[indexSecond].pro_list[
                indexThree
              ].pro_num
            );
        } else if (
          that.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
            .is_check == 0
        ) {
          that.allPrudctList[index].shop_info[indexSecond].pro_list[
            indexThree
          ].is_check = 1;

          that.total_num =
            parseInt(that.total_num) +
            parseInt(
              that.allPrudctList[index].shop_info[indexSecond].pro_list[
                indexThree
              ].pro_num
            );
        }
        
        let num1 = 0;
        let num2 = 0;

        // 定义一个数组,将所有数据拼接起来
        let pinjieArr = [];
        for (let j = 0; j < that.allPrudctList[index].shop_info.length; j++) {
          let pro_list_value = that.allPrudctList[index].shop_info[j].pro_list;
          pinjieArr.push(pro_list_value);
        }
        for (let i = 0; i < pinjieArr.length; i++) {
          for (let j = 0; j < pinjieArr[i].length; j++) {
            num1++;
            if (pinjieArr[i][j].is_check == 1) {
              num2++;
            }
          }
        }
        if (num1 == num2) {
          that.allPrudctList[index].ifShow = 1;
        } else {
          that.allPrudctList[index].ifShow = 0;
        }

        let numFlg = 0;
        // 变量
        let dataFlg = 0;
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if(that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 0){
                dataFlg = 1
              }
              if (
          that.allPrudctList[i].shop_info[j].pro_list[k]
            .is_check == 1
        ) {
          numFlg++
        }
            }
          }
        }
        that.numFlg = parseInt(numFlg);
        // 判断全选的状态
        if(dataFlg){
          that.shoppingContent_radioFlg = false;
        }else{
          that.shoppingContent_radioFlg = true;
        }
      }
    },
    // 管理和完成状态的切换
    managementClick(num) {
      let that =this
      // 管理flgManagement为1,完成flgManagement为2

      if (that.flgManagement == 2) {
        that.flgManagement = 1;
        // 请求接口
        that.againRequest();
      } else if (that.flgManagement == 1) {
        that.flgManagement = 2;


    let numFlg = 0;
        // 变量
        let dataFlg = 0;
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if(that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 0){
                dataFlg = 1
              }
              if (
                that.allPrudctList[i].shop_info[j].pro_list[k]
                  .is_check == 1
                ) {
                numFlg++
              }
            }

          }
        }
        that.numFlg = parseInt(numFlg);
        // 判断全选的状态
        if(dataFlg){
          that.shoppingContent_radioFlg = false;
        }else{
          that.shoppingContent_radioFlg = true;
        }


          // for (var i = 0; i < that.allPrudctList.length; i++) {
          //       //有效商品
          //       that.allPrudctList[i].ifShow = 1;
          //       // 用来判断商铺是否选中
          //       let lengthVlaue = 0;
          //       // 用来判断商铺是否可选
          //       let shopIfChange = 0;

          //       let dataAllXuan = 0
               
          //     // 用来判断商铺是否可全选
          //     let shopIfValue2  = 0;
          //       for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
          //         let isCheckValue = that.allPrudctList[i].shop_info[j].pro_list.filter(
          //           item => item.is_check == 0
          //         );

          //         // 添加字段用于判断商铺是否可选
          //         that.allPrudctList[i].shopIfChange = shopIfChange;
          //         for (
          //           let k = 0;
          //           k < that.allPrudctList[i].shop_info[j].pro_list.length;
          //           k++
          //         ) {
          //           if (that.allPrudctList[i].shop_info[j].pro_list[k].is_buy == 1) {
          //             dataAllXuan = 1;
          //             lengthVlaue++
          //           }
          //         }

          //        let shopIfValue3 = that.allPrudctList[i].shop_info[j].pro_list.filter(
          //           item => item.is_check == 1
          //         );
          //         shopIfValue2 = shopIfValue3.length + shopIfValue2
          //       }

          //       if (shopIfValue2 == lengthVlaue) {
          //         that.allPrudctList[i].ifShow = 1;
          //       } else {
          //         that.allPrudctList[i].ifShow = 0;
          //       }

          //       //  判断用于商铺全选
          //         let if_quanxuan = that.allPrudctList.filter(function(e) {
          //           return e.ifShow == 0;
          //         });
          //         if (if_quanxuan.length) {
          //           that.shoppingContent_radioFlg = false;
          //         } else {
          //           that.shoppingContent_radioFlg = true;
          //         }
               

          //       // 判断用于底部全选按钮
          //       if (dataAllXuan) {
          //         that.allPrudctList[i].ifAllXuan = 1;
          //       } else {
          //         that.allPrudctList[i].ifAllXuan = 0;
          //       }
          //     }
          //   }
        
      }
    },

    // 获得转盘机会弹窗
    openRotary() {
      this.$refs.CustomVouchersRotary.showMask();
    },
    // 关闭转盘机会弹窗
    closeRotary() {
      this.$refs.CustomVouchersRotary.maskClickTwo();
    },

    // 关闭优惠券弹窗
    closeVouchersBtn() {
      this.$refs.CustomVouchers.maskClickHidden();
      this.allCouponsList = this.allCouponsList2;
      this.allCouponsListChange = [];
    },

    // 删除商品弹出框按钮
    deleteBtn() {
      let that = this
      let deleteValue = 0;
      for (let i = 0; i < that.allPrudctList.length; i++) {
        for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
          for (
            let k = 0;
            k < that.allPrudctList[i].shop_info[j].pro_list.length;
            k++
          ) {
            if (that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1) {
              deleteValue = 1;
            }
          }
        }
      }

      if (deleteValue == 1) {
        this.$refs.numbersInfo.showBounced();
        this.deleteInfo = 2;
        this.deleteConditions = 2;

      }
      
    },

    // 删除商品取消按钮
    cancelBtn() {
      this.$refs.numbersInfo.coloseBounced();
    },
    // 删除商品确认按钮
    confirmBtn() {
      this.$refs.numbersInfo.coloseBounced();
      let that = this;
      // 删除单个商品
      if (that.deleteInfo == 1) {
        // 调取删除接口
        this.changeCookie(
          this.allPrudctList[this.index].shop_info[this.indexSecond].pro_list[
            this.indexThree
          ].pro_id.split(","),
          this.allPrudctList[this.index].shop_info[this.indexSecond].pro_list[
            this.indexThree
          ].param_id.split(","),
          0
        );
        this.flgDeleted = 1;

        if (this.flgManagement == 1) {
          // this.againRequest();
        } else {
          this.allPrudctList[this.index].shop_info[
            this.indexSecond
          ].pro_list.splice(this.indexThree, 1);
          layer.msg("删除成功", { time: 1200 });
        }
      } else if (that.deleteInfo == 2 || that.deleteInfo == 3) {
        //删除一组商品
        let idArr = [],
          param_id_arr = [];

        if (this.flgManagement == 1) {
          for (let i = 0; i < this.allFailureList[0].pro_list.length; i++) {
            idArr.push(this.allFailureList[0].pro_list[i].pro_id);
            param_id_arr.push(this.allFailureList[0].pro_list[i].param_id);
          }

          this.flgDeleted = 1;
          // 调取删除方法
          this.changeCookie(idArr, param_id_arr, 0);
        } else {
        // 判断是点击全部删除还是点击删除失效商品
        //一键清空失效商品
        if(that.deleteInfo == 3){
            let numLength = 0;
              if (that.allFailureList[0].pro_list.length) {
                for (
                  let k =
                    that.allFailureList[0].pro_list.length - 1;
                  k >= 0;
                  k--
                ) {
                    idArr.push(
                      that.allFailureList[0].pro_list[k].pro_id
                    );
                    param_id_arr.push(
                      that.allFailureList[0].pro_list[k].param_id
                    );
                    that.allFailureList[0].pro_list.splice(k, 1);
              }
            }
            // if (numLength == 0) {
            //   that.allPrudctList.splice(i, 1);
            // }

           that.allFailureList = []
          // 调取删除方法
          this.changeCookie(idArr, param_id_arr, 0);
          layer.msg("删除成功", { time: 1200 });
        }else if(that.deleteInfo == 2){//清空所有商品
          for (let i = that.allPrudctList.length - 1; i >= 0; i--) {
            for (
              let j = that.allPrudctList[i].shop_info.length - 1;
              j >= 0;
              j--
            ) {
              if (that.allPrudctList[i].shop_info[j].pro_list.length) {
                for (
                  let k =
                    that.allPrudctList[i].shop_info[j].pro_list.length - 1;
                  k >= 0;
                  k--
                ) {
                  if (
                    that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1
                  ) {
                    idArr.push(
                      that.allPrudctList[i].shop_info[j].pro_list[k].pro_id
                    );
                    param_id_arr.push(
                      that.allPrudctList[i].shop_info[j].pro_list[k].param_id
                    );
                    that.allPrudctList[i].shop_info[j].pro_list.splice(k, 1);
                  }
                }
              }
            }
          }

          for (let i = that.allPrudctList.length - 1; i >= 0; i--) {
            let numLength = 0;
            for (
              let j = that.allPrudctList[i].shop_info.length - 1;
              j >= 0;
              j--
            ) {
              if (that.allPrudctList[i].shop_info[j].pro_list.length) {
               numLength = 1;
              }
            }
            if (numLength == 0) {
              that.allPrudctList.splice(i, 1);
            }
          }
          // 调取删除方法
          this.changeCookie(idArr, param_id_arr, 0);
          layer.msg("删除成功", { time: 1200 });
        }
      }
      }
    },
    // 数量输入获取焦点事件
    numbersFocus(index, indexSecond, indexThree) {
      let that = this;
      that.$refs.writeNumberInfo.showBounced();
      // 让弹出框的数量和输入的数量一致
      that.fillInText = parseInt(
        that.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
          .pro_num
      );

      // 把index存起来
      that.index = index;
      that.indexSecond = indexSecond;
      that.indexThree = indexThree;

      // if (this.fillInText <= 1) {
      //   // that.changMumImg = "https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceNo.png";
      // } else {
      //   that.changMumImg = "https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceYes.png";
      // }
    },
    // 弹出框数量输入商品取消按钮
    cancelNumBtn() {
      this.$refs.writeNumberInfo.coloseBounced();
    },
    // 弹出框数量输入商品确认按钮
    confirmNumBtn() {
      let that = this;
      if (!that.ifJudge) {
        return;
      }
      that.$refs.writeNumberInfo.coloseBounced();
      // 只有输入数量改变时,才存入cookie
      if (
        parseInt(that.fillInText) !=
        parseInt(
          that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
            that.indexThree
          ].pro_num
        )
      ) {
        that.changeCookie(
          that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
            that.indexThree
          ].pro_id.split(","),
          this.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
            that.indexThree
          ].param_id.split(","),
          parseInt(that.fillInText)
        );

        if (this.flgManagement == 1) {
          let idsList = [];
          // 将选中的单选按钮存到data中
          if (
            this.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
              that.indexThree
            ].is_check == 0 ||
            this.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
              that.indexThree
            ].is_check == 1
          ) {
            this.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
              that.indexThree
            ].is_check = 1;

            // 选中的单选按钮数组
            let idsList = [];
            for (let i = 0; i < that.allPrudctList.length; i++) {
              for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
                for (
                  let k = 0;
                  k < that.allPrudctList[i].shop_info[j].pro_list.length;
                  k++
                ) {
                  if (
                    that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1
                  ) {
                    let idAll =
                      that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                      "_" +
                      that.allPrudctList[i].shop_info[j].pro_list[k].param_id;
                    idsList.push(idAll);
                  }
                }
              }
            }

            // 将选中的单选按钮存到data中
            // idsList.push(
            //   this.allPrudctList[that.index].shop_info[that.indexSecond]
            //     .pro_list[that.indexThree].pro_id +
            //     "_" +
            //     this.allPrudctList[that.index].shop_info[that.indexSecond]
            //       .pro_list[that.indexThree].param_id
            // );
            this.ids = idsList;
            this.againRequest(100);
          }
        } else {
          this.allPrudctList[this.index].shop_info[this.indexSecond].pro_list[
            this.indexThree
          ].pro_num = parseInt(that.fillInText);
        }
      }
    },
    //页面中数量增加事件
    addNumber(index, indexSecond, indexThree) {
      let that = this;
      this.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
        .pro_num++;
      this.index = index;
      this.indexSecond = indexSecond;
      this.indexThree = indexThree;
      // 调取cookie方法
      this.changeCookie(
        this.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].pro_id.split(","),
        this.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].param_id.split(","),
        this.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
          .pro_num
      );

      this.fillInTextFun(1, 1);
      if (this.flgManagement == 1) {
        let idsList = [];
        if (
          this.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
            .is_check == 0
        ) {
          this.allPrudctList[index].shop_info[indexSecond].pro_list[
            indexThree
          ].is_check = 1;

          // 将选中的单选按钮存到data中
          // let idsValue =
          //   this.allPrudctList[index].shop_info[indexSecond].pro_list[
          //     indexThree
          //   ].pro_id +
          //   "_" +
          //   this.allPrudctList[index].shop_info[indexSecond].pro_list[
          //     indexThree
          //   ].param_id;
          // idsList.push(idsValue);
        }
        // 选中的单选按钮数组
        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if (
                that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1
              ) {
                let idAll =
                  that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                  "_" +
                  that.allPrudctList[i].shop_info[j].pro_list[k].param_id;
                idsList.push(idAll);
              }
            }
          }
        }

        this.ids = idsList;
        this.againRequest(100);
      }
    },
    // 页面中数量减少事件
    reduceNumber(index, indexSecond, indexThree) {
      let that = this;
      this.index = index;
      this.indexSecond = indexSecond;
      this.indexThree = indexThree;
      if (
        this.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
          .pro_num <= 1
      ) {
        this.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].pro_num = 1;
        this.$refs.numbersInfo.showBounced();
        this.deleteInfo = 1;
        return;
      }
      this.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
        .pro_num--;

      this.changeCookie(
        this.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].pro_id.split(","),
        this.allPrudctList[index].shop_info[indexSecond].pro_list[
          indexThree
        ].param_id.split(","),
        this.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
          .pro_num
      );
      if (this.flgManagement == 1) {
        let idsList = [];
        // 将选中的单选按钮存到data中
        if (
          this.allPrudctList[index].shop_info[indexSecond].pro_list[indexThree]
            .is_check == 0
        ) {
          this.allPrudctList[index].shop_info[indexSecond].pro_list[
            indexThree
          ].is_check = 1;
        }

        for (let i = 0; i < that.allPrudctList.length; i++) {
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              if (
                that.allPrudctList[i].shop_info[j].pro_list[k].is_check == 1
              ) {
                let idAll =
                  that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                  "_" +
                  that.allPrudctList[i].shop_info[j].pro_list[k].param_id;
                idsList.push(idAll);
              }
            }
          }
        }
        this.ids = idsList;

        this.againRequest(100);
      }
    },

    // 自定义数量变化方法
    fillInTextFun(type1, type2) {
      let that = this;
      // 库存
      let kuncun = parseInt(
        that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
          that.indexThree
        ].pro_stock
      );
      // 最小定量
      let zuiSamll = parseInt(
        that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
          that.indexThree
        ].pro_small
      );
      // 是否有最大限购要求
      let restrict_num = parseInt(
        that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
          that.indexThree
        ].restrict_num
      );

      // 加加调取方法
      if (type1 == 1) {
        // 如果大于库存
        let max = parseInt(kuncun);
        let tmp_flag = 0;
        if (restrict_num > 0) {
          if (restrict_num < kuncun) {
            tmp_flag = 1;
            max = parseInt(restrict_num);
          }
        }

        if (that.fillInText > max) {
          that.ifJudge = false;

          setTimeout(function() {
            that.ifJudge = true;
          }, 500);
          let msg = tmp_flag
            ? that.goumaichaoguoxiangou
            : that.goumaichaoguokucun;
          layer.msg(msg, { time: 1200 });
          that.fillInText = parseInt(max);
          return;
        }
        if (that.fillInText > 1) {
          that.changMumImg = "https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceYes.png";
        }
      }

      // 减减调取方法
      if (type2 == 2) {
        let min = kuncun;
        let tmp_flag = 0;

        if (parseInt(that.fillInText) < parseInt(zuiSamll)) {
          // that.ifJudge = false;

          setTimeout(function() {
            that.ifJudge = true;
          }, 500);
          // let msg = that.weidadaozuixiaoqishoushuliang;
          // layer.msg(msg, { time: 1200 });
          // that.fillInText = parseInt(zuiSamll);
          // return;
        }

        if (that.fillInText <= 1) {
          // that.changMumImg = "https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/reduceNo.png";
          that.fillInText = 1;
          return false;
        }
      }
    },

    // 弹出框数量增加事件
    fillInAdd(e) {
      // 阻止冒泡
      // e.stopPropagation();
      let that = this;
      if (!that.ifJudge) {
        return;
      }
      let fillInTextResult = parseInt(that.fillInText);
      that.fillInText = parseInt(fillInTextResult + 1);
      this.fillInTextFun(1, 1);
    },
    // 弹出框数量减少事件
    fillInReduce(e) {
      // 阻止冒泡
      // e.stopPropagation();
      let that = this;
      if (!that.ifJudge) {
        return;
      }
      let fillInTextResult = parseInt(that.fillInText);
      that.fillInText = parseInt(fillInTextResult - 1);

      this.fillInTextFun(2, 2);
    },
    // 弹出框输入数量失去焦点事件
    changFillText() {
      let that = this;
      let zuiSamll = parseInt(
        that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
          that.indexThree
        ].pro_small
      );

      if (this.fillInText == "") {
        if (
          that.allPrudctList[that.index].shop_info[that.indexSecond]
            .rule_type != "1"
        ) {
          this.fillInText = parseInt(zuiSamll);
        } else {
          this.fillInText = 1;
        }
        this.fillInTextFun(1, 2);
      }
    },
    // 弹出框数量变化事件
    numberInput() {
      let that = this;
      let zuiSamll = parseInt(
        that.allPrudctList[that.index].shop_info[that.indexSecond].pro_list[
          that.indexThree
        ].pro_small
      );

      if (this.fillInText != "") {
        var re = /^\d+$/; //判断字符串是否为数字
        if (re.test(this.fillInText)) {
          if (
            parseInt(this.fillInText) <= parseInt(zuiSamll) &&
            that.allPrudctList[that.index].shop_info[that.indexSecond]
              .rule_type != "1"
          ) {
            // this.fillInText = parseInt(zuiSamll);
          } else if (
            that.allPrudctList[that.index].shop_info[that.indexSecond]
              .rule_type == "1" &&
            parseInt(this.fillInText) <= 1
          ) {
            this.fillInText = 1;
          }
        } else {
          if (
            that.allPrudctList[that.index].shop_info[that.indexSecond]
              .rule_type != "1"
          ) {
            // this.fillInText = parseInt(zuiSamll);
          } else {
            this.fillInText = 1;
          }
        }
        this.fillInTextFun(1, 2);
      }
    },

    // 尺寸选择
    changSizeClick(sizeId) {
      for (let i = 0; i < this.sizeList.length; i++) {
        if (i == sizeId) {
          this.sizeList[i].active = 1;
        } else {
          this.sizeList[i].active = 0;
        }
      }
    },

    // 规格弹出框数量减少
    // reduceBuyNumbers() {
    //   this.changeNumbers = parseInt(this.changeNumbers) - 1;
    //   if (parseInt(this.changeNumbers) <= 1) {
    //     this.changeNumbers = 1;
    //   }
    // },
    // 规格弹出框数量增加
    // addBuyNumbers() {
    //   this.changeNumbers = parseInt(this.changeNumbers) + 1;
    // },

    //将新规格加入购物车
    joinCat() {
      let that = this;
      // 取出颜色
      for (let i = 0; i < that.colorList.length; i++) {
        if (that.colorList[i].active == 1) {
          that.bouncedColor = that.colorList[i].colorValue;
        }
      }
      // 取出尺码
      for (let i = 0; i < that.sizeList.length; i++) {
        if (that.sizeList[i].active == 1) {
          that.bouncedSize = that.sizeList[i].colorValue;
        }
      }
      // 取出购买数量
      that.bouncedNumber = that.changeNumbers;
      // 让buyNow的值变为1,证明点击加入购物车了
      this.buyNow = 1;

      // 重新赋值规格参数
      that.shopCatList[that.indexShoping].specifications =
        that.bouncedColor + " " + that.bouncedSize;
      // 重新赋值数量
      that.shopCatList[that.indexShoping].value = parseInt(that.bouncedNumber);
      // 关闭弹窗
      this.$refs.shoppingStatus.maskClickHidden();
    },

    // 删除失效商品
    clearShop(index, indexSecond) {
      let that = this
      // this.allFailureList.splice(index, 1);
      // if (this.allFailureList.length == 0) {
      //   this.ifFailureDate = false;
      // }
      // 调取cookie方法
      that.changeCookie(
        // "add",
        that.allFailureList[index].pro_list[indexSecond].pro_id.split(","),
        that.allFailureList[index].pro_list[indexSecond].param_id.split(","),
        0
      );
      that.flgDeleted = 1;

      setTimeout(function(){
        that.againRequest();
      },300)
    },

    // 一键清空失效商品
    emptyClick() {
      this.$refs.numbersInfo.showBounced();
      this.deleteInfo = 3;
      // this.ifFailureDate = false;

      // let idArr = [],
      //   param_id_arr = [];
      // for (let i = 0; i < this.allFailureList[0].pro_list.length; i++) {
      //   idArr.push(this.allFailureList[0].pro_list[i].pro_id);
      //   param_id_arr.push(this.allFailureList[0].pro_list[i].param_id);
      // }
      // // 调取删除方法
      // this.changeCookie(idArr, param_id_arr, 0);
      // // this.againRequest();
    },

    // 满减详情弹窗
    xiangqingPopup(index, indexSecond, indexThree, type, typeManjian) {
      this.$refs.CustomTimeLimit.showCustom();
      // 满减
      if (typeManjian == 2 && type != 4 && type != 1) {
        this.xinashigouType = typeManjian;
        // 标题
        this.fullRedTitle = this.allPrudctList[index].shop_info[
          indexSecond
        ].rule_title;
        // 名称
        this.fullRedName = this.allPrudctList[index].shop_info[
          indexSecond
        ].rule_tag;

        // 满减信息
        let rule_infoResult = this.allPrudctList[index].shop_info[indexSecond]
          .rule_alert;
        // 活动时间
        let activityTime = this.allPrudctList[index].shop_info[indexSecond]
          .rule_time;
        this.fullRedInfo = rule_infoResult;
        this.activityTimes = activityTime;

        // 更多可用商品链接
        this.rule_href =this.allPrudctList[index].shop_info[indexSecond].rule_href

        return;
      }
      //  微团购
      // if (type == 1) {
      //   this.xinashigouType = type;
      // }
      // 限时购
      if (type == 4 || type == 1) {
        this.xinashigouType = type;
        // 标题
        this.fullRedTitle = this.allPrudctList[index].shop_info[
          indexSecond
        ].pro_list[indexThree].explain_info.active_text;
        // 名称
        this.fullRedName = this.allPrudctList[index].shop_info[
          indexSecond
        ].pro_list[indexThree].pro_tag;
        // 活动时间
        this.xsgStar_time = this.allPrudctList[index].shop_info[
          indexSecond
        ].pro_list[indexThree].start_time;

        this.xsgEnd_time = this.allPrudctList[index].shop_info[
          indexSecond
        ].pro_list[indexThree].end_time;
        return;
      }
    },

    // 关闭满减弹窗
    closeTimeLimitBtn() {
      this.$refs.CustomTimeLimit.maskClickHidden();

      this.fullRedTitle = "";
      this.fullRedName = "";
      this.fullRedInfo = "";
      this.activityTimes = "";
      this.xsgStar_time = "";
      this.xsgEnd_time = "";
    },
    // 批发弹窗
    wholesaleClick(index, indexSecond, indexThree, num) {
      this.$refs.CustomWholesale.showCustom();
      let param_name = this.allPrudctList[index].shop_info[indexSecond]
        .pro_list[indexThree].param_name;

      // 组的按钮点击
      if (num == 1) {
        this.flgWholesaleHuige = false;
        this.rule_alert_Array = this.allPrudctList[index].shop_info[
          indexSecond
        ].rule_alert;
      } else if (num == 2) {
        //单个按钮点击
        this.flgWholesaleHuige = true;

        this.flgWholesaleHuigeValue = param_name;
        if (param_name == "") {
          this.flgWholesaleHuige = false;
        }
        this.rule_alert_Array = this.allPrudctList[index].shop_info[
          indexSecond
        ].pro_list[indexThree].explain_info.rule_alert;
      }

      // if (this.allPrudctList[index].shop_info[indexSecond].rule_type == "1") {

      //   // 不是组的情况
      // } else if (param_name) {

      // }
    },

    // 关闭批发弹窗
    closewholesaleBtn() {
      this.$refs.CustomWholesale.maskClickHidden();
      this.rule_alert_Array = [];
    },
    // 点击放大图片
    openImg(imgUrl) {
      this.imgFlg = true;
      this.shopImgSrc = imgUrl;
    },
    // 关闭放大的图片
    colseImg() {
      this.imgFlg = false;
      this.shopImgSrc = "";
    },

    // 获取时间方法
    getTimeFun() {
      let that = this;

      if(this.allPrudctList.length > 0 && that.pro_type_value){

      setInterval(function() {
        // let allPrudctListResult = that.allPrudctList;
        for (let i = 0; i < that.allPrudctList[0].shop_info.length; i++) {
          for (
            let j = 0;
            j < that.allPrudctList[0].shop_info[i].pro_list.length;
            j++
          ) {
            if (
              (that.allPrudctList[0].shop_info[i].pro_list[j].pro_type == 1 ||
                that.allPrudctList[0].shop_info[i].pro_list[j].pro_type == 4) &&
              that.allPrudctList[0].shop_info[i].pro_list[j].pro_time_range == 0
            ) {
              // 获取本地时间(时间戳)
              let dateLocal = Date.parse(new Date());

              // 获取接口返回的时间
              let timeValue = that.allPrudctList[0].shop_info[i].pro_list[j].end_time
              var arrTime = timeValue .split(/[- : \/]/);
              var newDate = new Date(arrTime[0], arrTime[1]-1, arrTime[2], arrTime[3], arrTime[4], arrTime[5]);
              var newDateValue = Date.parse(newDate)
              // 获取差值
              let difference = parseInt(newDateValue) - parseInt(dateLocal);

              // 将时间戳转换为时间
              var days = parseInt(Math.floor(difference / (1000 * 60 * 60 * 24)));
              
              var hours = parseInt(
                (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
              var minutes = parseInt(
                (difference % (1000 * 60 * 60)) / (1000 * 60)
              );
              var seconds = (difference % (1000 * 60)) / 1000;
              var JsonTime = {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
              };
              if (
                that.allPrudctList[0].shop_info[i].pro_list[j].JsonTime ==
                undefined
              ) {
                that.allPrudctList[0].shop_info[i].pro_list[j].JsonTime = JsonTime
              }else{
               that.$set(
                  that.allPrudctList[0].shop_info[i].pro_list[j],
                  "JsonTime",
                  JsonTime
                );
                that.$forceUpdate();
              }
            }
          }
        }
      }, 1000);
      }
    },

    // 优惠券弹窗
    vouchersClick(id) {
      let that = this;
      let user_id = this.$cookies.get("zz_userid");

      // 获取 zz_userid判断是否登录
      if (user_id != undefined || user_id != null || user_id > 0) {
        this.zz_userid = user_id;
      } else {
        this.zz_userid = 0;
      }

      for (let i = 0; i < that.allPrudctList.length; i++) {
        if (id == that.allPrudctList[i].shop_id) {
          let ids = that.allPrudctList[i].shop_id + "_";
          let allIdList = [];
          let LastIds = "";
          let jsonPic = {};
          for (let j = 0; j < that.allPrudctList[i].shop_info.length; j++) {
            for (
              let k = 0;
              k < that.allPrudctList[i].shop_info[j].pro_list.length;
              k++
            ) {
              ids =
                ids +
                that.allPrudctList[i].shop_info[j].pro_list[k].pro_id +
                ",";

              // 这个用限时优惠券中某个优惠券有哪些可用商品
              let jsonResult = {
                img_pic: that.allPrudctList[i].shop_info[j].pro_list[k].pro_pic,
                price: that.allPrudctList[i].shop_info[j].pro_list[k].pro_price
              };
              jsonPic[
                that.allPrudctList[i].shop_info[j].pro_list[k].pro_id
              ] = jsonResult;
            }
          }

          allIdList.push(ids.slice(0, ids.length - 1));
          for (let i = 0; i < allIdList.length; i++) {
            LastIds += allIdList[i];
          }
          that.idsFlg = LastIds;

          that.PrepicturesList = jsonPic;
        }
      }

      that.daijinquanFun();
      // 把优惠券的商铺id存起来,一遍再次渲染时调用
      // that.vouchersTemOId = id;

      // 请求优惠券接口
      setTimeout(function() {
        that.$refs.CustomVouchers.showCustom();
      }, 200);
    },

    // 点击优惠券“立即领取”
    receiveQuan(coupon_id, shop_id) {
      let that = this;
      this.receiveQuanFun(coupon_id, shop_id);
    },
    // 优惠券领取接口
    receiveQuanFun(coupon_id, shop_id) {
      let that = this;
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: {
          username: this.$route.query.username,
          method: "getcoupon",
          coupon_id: coupon_id,
          type: 1
        },
        // param: { username: this.$route.query.username },
        success: res => {
          if (res.code == 200) {
            //弹出警示信息
            layer.msg(res.msg, { time: 1200 });
            // 调用优惠券信息接口
            that.daijinquanFun();
          } else {
            //弹出警示信息
            layer.msg(res.msg, { time: 1200 });
            // 调用优惠券信息接口
            that.daijinquanFun();
          }
        },
        error: () => {
          let that = this
          setTimeout(function() {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }, 300);

          // //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.home_url;
          //       });
          // });
        }
      });
    },

    // 优惠券信息接口的封装
    daijinquanFun() {
      let that = this;
      // 请求优惠券接口
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: {
          username: this.$route.query.username,
          method: "coupon",
          ids: that.idsFlg
        },
        success: res => {
          let that = this;
          if (res.code == 200) {
            // 循环的数据
            that.allCouponsListChange = res.data[0].info;
            // is_login用来判断是否登录
            that.is_login = res.is_login;
            // name
            that.name = res.name;
            // 顶部title
            that.title = res.title;
            //  使用规则
            that.use_rule = res.use_rule;
            // 立即领取
            that.likelingqu = res.likelingqu;
            // 已领取
            that.yilingqu = res.yilingqu;
            // 有效期
            that.period_of_validity = res.period_of_validity;
            // 至
            that.zhi = res.zhi;
            // // 金币符号
            // that.currency_symbol = res.currency_symbol;
            // 标题
            that.available_info = res.available_info;
          } else {
            //警告信息
            // 让商品显示
            that.ifDate = true;
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.message, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
        },
        error: () => {
          let that = this
          setTimeout(function() {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }, 300);

          // //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.home_url;
          //       });
          // });
        }
      });
    },
    // 去逛逛点击之后跳转
    home_Link() {
      location.href = this.home_url;
    },
    // 点击返回按钮
    goLink() {
      if (document.referrer.length > 0) {
        history.back();
      } else {
        location.href = this.home_url;
      }
    },
    // 商品列表点击跳转
    goDetailPage(link,param_id) {
      location.href = link+'?param_id='+param_id;
    },
    // 点击去结算
    qujiesuanFun() {
      if (this.zz_userid == 0) {
        location.href =
          "/dom/denglu.php?username=" + this.$route.query.username + "&wap=1&trespass="+this.self_href;
      } else {
        this.$cookies.set("is_liji", 0, 3600 * 24);
        this.$cookies.set("liji_sn", "", 3600 * 24);
        this.$cookies.set("liji_param_pro", "", 3600 * 24);
        this.$cookies.set("liji_pro_num", "", 3600 * 24);

        location.href =
          "/dom/sc_orderbuy.php?username=" +
          this.$route.query.username +
          "&wap=1&orderType=pro";
      }
    },
    // 没登录时,点击立刻领取
    lingquFun() {
      location.href =
        "/dom/denglu.php?username=" +
        this.$route.query.username +
        "&wap=1&trespass=" +
        this.self_href;
    },

    // 数据再次请求的接口封装
    againRequest(type) {
      var width = document.body.offsetWidth;
      var wdithpx = width / 2 - 37 / 2;
      //加载层-默认风格
      layui.use("layer", function() {
        layer.ready(function() {
          layer.load({
            shade: false,
            offset: ["50%", wdithpx]
          });
        });
      });
      let that = this;
      that.numInterface = 0;
      // 判断去结算是否可点击
      // that.clickSettlement = false;
      // 请求购物车列表接口
      // var param = { username: this.$route.query.username,type:1};
      // if (ids) {
      //   param.ids = ids;
      // }
      var paramValue;
      if (this.flgManagement == 1) {
        if (that.ids.length) {
          let idsValue = that.ids;
          let ids = idsValue.join(",");
          // 购物车列表
          // paramValue = {
          //   username: this.$route.query.username,
          //   ids: ids,
          //   check: 1
          // };
          if(type == 100){
            paramValue = {
            username: this.$route.query.username,
            type: 1,
            ids: ids,
            check: 1,
            car_change_num:1
          };
          }else{
             paramValue = {
            username: this.$route.query.username,
            type: 1,
            ids: ids,
            check: 1
          };
          }
        } else {
          // paramValue = { username: this.$route.query.username, check: 1 };
          if(type == 100){
            paramValue = {
            username: this.$route.query.username,
            type: 1,
            check: 1,
            car_change_num:1
          };
          }else{
            paramValue = {
            username: this.$route.query.username,
            type: 1,
            check: 1
          };
          }
          
        }
      } else {
        if(type == 100){

          paramValue = {
            username: this.$route.query.username,
            type: 1,
            check: 1,
            car_change_num:1
          };
        }else{
          paramValue = {
            username: this.$route.query.username,
            type: 1,
            check: 1
          };
        }
      }

      // 请求购物车列表接口
       this.$F.Response({
        url: "mallorder/api/cart.php",
        param: paramValue,
        success: res => {
          if (res.code == 200) {
            setTimeout(function() {
                layui.use("layer", function() {
                  // 关闭loading
                  layer.closeAll("loading");
                });
              }, 400);
            let numInterface = that.numInterface;
            that.numInterface = numInterface + 1;
            if (that.numInterface == 2) {
              setTimeout(function() {
                layui.use("layer", function() {
                  // 关闭loading
                  layer.closeAll("loading");
                });
              }, 500);
            }
            that.allTextdata = res.data
            
            // title
            that.pageTitle = res.data.gouwuche
            // 金钱符号
            that.currency_symbol = res.data.currency_symbol;
            // 判读跳转方式
            that.return_type = res.data.return_type;
            // 首页链接
            that.home_url = res.data.home_url;
            // 登录页链接
            that.self_href = res.data.self_href;
            //总金额
            that.total_price = res.data.total_price;
            // 满减金额
            that.cut_money = res.data.cut_money;
            // 必须使用
            that.bixushiyong = res.data.bixushiyong;
            // 页面标题
            that.gouwuche = res.data.gouwuche;
            //购物车还是空的
            (that.gouwuchehaishikongde = res.data.gouwuchehaishikongde),
              // 活动已结束
              (that.huodongyijieshu = res.data.huodongyijieshu),
              // 减
              (that.jian = res.data.jian),
              // 据活动结束还剩
              (that.juhuodongjieshuhaisheng = res.data.juhuodongjieshuhaisheng),
              // 满
              (that.man = res.data.man),
              // 全选
              (that.quanxuan = res.data.quanxuan),
              // 去逛逛
              (that.quguangguang = res.data.quguangguang),
              // 删除
              (that.shanchu = res.data.shanchu),
              // 完成
              (that.wancheng = res.data.wancheng),
              // 消费积分重命名
              (that.xf_name = res.data.xf_name),
              // 详情
              (that.xiangqing = res.data.xiangqing),
              // 一键清空
              (that.yijianqingkong = res.data.yijianqingkong),
              // 已选
              (that.yixuan = res.data.yixuan),
              // 自营
              (that.ziying = res.data.ziying),
              // 重选
              (that.chongxuan = res.data.chongxuan),
              // 合计
              (that.heji = res.data.heji),
              // 请输入购买数量
              (that.qingshurugoumaishuliang = res.data.qingshurugoumaishuliang),
              // 确定要删除此商品吗?
              (that.quedingyaoshanchucishangpinma =
                res.data.quedingyaoshanchucishangpinma),
              // 确定要删除选中商品吗?
              (that.quedingyaoshanchuxuanzhongshangpinma =
                res.data.quedingyaoshanchuxuanzhongshangpinma),
              // 去结算
              (that.qujiesuan = res.data.qujiesuan),
              // 微团购
              (that.weituangou = res.data.weituangou),
              // 限时购
              (that.xianshigou = res.data.xianshigou),
              // 已售罄
              (that.yishouqing = res.data.yishouqing),
              // 已满减
              (that.yimanjian = res.data.yimanjian),
              // 已选
              (that.yixuan = res.data.yixuan);
            // 起售
            that.qishou = res.data.qishou;
            // 确认
            that.queren = res.data.queren;
            // 取消
            that.quxiao = res.data.quxiao;
            // 活动截止至
            that.huodongjiezhizhi = res.data.huodongjiezhizhi;
            // 已选件数
            // that.numFlg = res.data.numFlg;
            // 去逛逛链接
            that.home_url = res.data.home_url;
            // 管理
            that.guanli = res.data.guanli;
            // 更多可用商品
            that.gengduokeyongshangpin = res.data.gengduokeyongshangpin;
            // 活动时间
            that.huodongshijian = res.data.huodongshijian;
            // 代金券
            that.daijinquan = res.data.daijinquan;
            // 限购
            that.xiangou = res.data.xiangou;
            // 购买超过库存
            that.goumaichaoguokucun = res.data.goumaichaoguokucun;
            // 购买超过限购
            that.goumaichaoguoxiangou = res.data.goumaichaoguoxiangou;
            // 未到达最小起售数量
            that.weidadaozuixiaoqishoushuliang =
              res.data.weidadaozuixiaoqishoushuliang;
            // 件
            that.danweijian = res.data.danweijian;
            // 起售
            that.qishou = res.data.qishou;
            // 至
            that.zhi = res.data.zhi;
            // 收起
            that.shouqi = res.data.shouqi;

            // 所有商品数组
            let newData = res.data.all_pro;
            // 等于0的时候购物车没有数据
            if (newData.length == 0) {
              that.ifDate = false;
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
              return false;
            }
            if (newData.length > 0) {
              that.ifDate = true;
            }
            // 定义一个空数组,用来存储有效商品
            let allPrudctListValue = [];
            // 定义一个数组用来存放失效商品,
            let allFailureList = []
            // 用来判断,已选多少件
            let numFlg = 0;
             // 定义变量,用于判断去结算是否可点击
                let SettleFlg = 0;
            for (var i = 0; i < newData.length; i++) {
              // 失效商品
              if (newData[i].shop_id == -1) {
                allFailureList = newData[i].shop_info;
                that.allFailureListName = newData[i].shop_name;
                that.ifFailureDate = true;
              } else {

                // 自定义对象,用来加入优惠券
                let jsonPic = {};
                // 自定义数组
                let allIdList = [];
                // 自定义变量
                let LastIds = "";

                //有效商品
                newData[i].ifShow = 1;
                // 先加上值,而后在改变值,如果在改变值的时候加字段,渲染会出问题
                newData[i].ifPre = true;
                // 用来判断商铺是否选中
                let lengthVlaue = 0;
                // 用来判断商铺是否可选
                let shopIfChange = 0;

                // 添加字段,用于判断底部是否可选择
                newData[i].ifAllXuan = 0;
                // 判断是否可选的前提变量
                let dataAllXuan = 0;
               
              // 用来判断商铺是否可全选
              let shopIfValue2  = 0;
                for (let j = 0; j < newData[i].shop_info.length; j++) {
                  let isCheckValue = newData[i].shop_info[j].pro_list.filter(
                    item => item.is_check == 0
                  );
                  if (newData[i].shop_info[j].rule_type == 1) {
                    if (isCheckValue.length) {
                      newData[i].shop_info[j].is_pifaZu = 0;
                    } else {
                      // 添加一个字段用来判断组的显示情况
                      newData[i].shop_info[j].is_pifaZu = 1;
                    }
                  }

                  let shopIfValue = newData[i].shop_info[j].pro_list.filter(
                    item => item.is_buy == 1
                  );
                  if (shopIfValue.length) {
                    shopIfChange++;
                  }

                  // 添加字段用于判断商铺是否可选
                  newData[i].shopIfChange = shopIfChange;
                  for (
                    let k = 0;
                    k < newData[i].shop_info[j].pro_list.length;
                    k++
                  ) {

                    if (newData[i].shop_info[j].pro_list[k].is_buy == 1) {
                      dataAllXuan = 1;
                      lengthVlaue++
                    }
                    

                    if (newData[i].shop_info[j].pro_list[k].is_check == 1) {
                      SettleFlg = 1;
                      numFlg++
                    }

                    if(newData[i].shop_info[j].pro_list[k].pro_type == 4){
                    that.pro_type_value = 1

                    // 获取本地时间(时间戳)
                    let dateLocal = Date.parse(new Date());
                    // 获取接口返回的时间
                    let timeValue = newData[i].shop_info[j].pro_list[k].end_time
                    var arrTime = timeValue .split(/[- : \/]/);
                    var newDate = new Date(arrTime[0], arrTime[1]-1, arrTime[2], arrTime[3], arrTime[4], arrTime[5]);
                    var newDateValue = Date.parse(newDate)
                    // 获取差值
                    let difference = parseInt(newDateValue) - parseInt(dateLocal);

                    // 将时间戳转换为时间
                    var days = parseInt(Math.floor(difference / (1000 * 60 * 60 * 24)));
                    var hours = parseInt(
                      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                    );
                    var minutes = parseInt(
                      (difference % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    var seconds = (difference % (1000 * 60)) / 1000;
                    var JsonTime = {
                      days: days,
                      hours: hours,
                      minutes: minutes,
                      seconds: seconds
                    };
                    newData[i].shop_info[j].pro_list[k].JsonTime = JsonTime;
                    }

                  }

                 let shopIfValue3 = newData[i].shop_info[j].pro_list.filter(
                    item => item.is_check == 1
                  );
                  shopIfValue2 = shopIfValue3.length + shopIfValue2
                
                }

                if (shopIfValue2 == lengthVlaue) {
                  newData[i].ifShow = 1;
                } else {
                  newData[i].ifShow = 0;
                }

                //  判断用于商铺全选
                  let if_quanxuan = newData.filter(function(e) {
                    return e.ifShow == 0;
                  });
                  if (if_quanxuan.length) {
                    that.shoppingContent_radioFlg = false;
                  } else {
                    that.shoppingContent_radioFlg = true;
                  }
               

                // 判断用于底部全选按钮
                if (dataAllXuan) {
                  newData[i].ifAllXuan = 1;
                } else {
                  newData[i].ifAllXuan = 0;
                }

                // allIdList.push(ids.slice(0, ids.length - 1));
                allPrudctListValue.push(newData[i]);
              }
            }

            // 判断去结算是否可点击
                if(SettleFlg){
                  that.clickSettlement = true;
                }else{
                  that.clickSettlement = false
                }
             // 判断已选多少件
                that.numFlg = numFlg;

            

            // 判断用于底部全选
            let if_ifAllXuan = newData.filter(function(e) {
              return e.ifAllXuan == 0;
            });
            if (if_ifAllXuan.length) {
              that.shoppingContent_radioFlg_no = false;
            } else {
              that.shoppingContent_radioFlg_no = true;
            }
            // 非失效商品
            that.allPrudctList = allPrudctListValue;
            // 失效商品
            that.allFailureList  = allFailureList

            that.getTimeFun();

            if (that.idsFlg != -1) {
            }
          } else if (res.data.code == 30001) {
            let numInterface2 = that.numInterface;
            that.numInterface = numInterface2 + 1;
            // 让没有商品显示
            that.ifDate = false;
            if (that.numInterface == 2) {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.data.message, {
                icon: 0,
                skin: "layer-ext-moon"
              },function () {
                   location.href = that.home_url;
                });
            });
          } else {
            let numInterface3 = that.numInterface;
            that.numInterface = numInterface3 + 1;
            if (that.numInterface == 2) {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }
            //警告信息
            // 让商品显示
            that.ifDate = true;
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              },function () {
                   location.href = res.data.home_url;
                });
            });
          }
        },
        error() {
          layui.use("layer", function() {
            // 关闭loading
            layer.ready(function() {
              layer.closeAll("loading");
            });
          });
          layui.use("layer", ()=> {
            layer.alert("请求失败", {
              icon: 0,
              skin: "layer-ext-moon"
            },()=> {
                   location.href = '/wap_'+ this.$route.query.username +'.html';
                });
          });
        }
      });

      // 请求购物车活动信息
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: { username: this.$route.query.username, method: "active" },
        success: res => {
          if (res.code == 200) {
            that.numInterface = that.numInterface + 1;

            that.acvityList = res.data;

            if (that.numInterface == 2) {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }
          } else if (res.code == 3001) {
            that.numInterface = that.numInterface + 1;
            if (that.numInterface == 2) {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.message, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          } else {
            that.numInterface = that.numInterface + 1;
            if (that.numInterface == 2) {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }
            //警告信息
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.message, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
        },
        error: () => {
          let that = this
          setTimeout(function() {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }, 300);

          // //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.home_url;
          //       });
          // });
        }
      });

     

      // 色系接口
    this.$F.Response({
      url: "mallorder/api/cart.php",
      param: { username: this.$route.query.username, method: "public" },
      success: res => {
        if (res.code == 200) {
          // 调取颜色
            setTimeout(function() {
              that.colorFun(res.data.color);
            }, 300);
        } else {
          //警告信息
          //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert(res.msg, {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   });
          // });
        }
      },
      error() {
        // let that = this
        // //弹出警示信息
        // layui.use("layer", function() {
        //   layer.alert("请求失败", {
        //     icon: 0,
        //     skin: "layer-ext-moon"
        //   },function () {
        //            location.href = that.home_url;
        //         });
        // });
      }
    });
    },

     // 失效商品点击跳转
      goLinked(url){
        location.href = url
      },


    // 更改接口
    changDates(ids, new_ids, num) {
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: {
          username: this.$route.query.username,
          method: "change",
          ids: ids,
          new_ids: new_ids,
          num: num
        },
        success: res => {
          if (res.code == 200) {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
            this.againRequest();
          }else{
            layui.use("layer", function() {
            layer.alert(res.msg, {
              icon: 0,
              skin: "layer-ext-moon"
            });
          });
          }
        },
        error: () => {
          let that = this
          setTimeout(function() {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }, 300);

          // //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.home_url;
          //       });
          // });
        }
      });
    },

    // 删除接口
    deleteDatas(ids) {
      let that = this;
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: {
          username: this.$route.query.username,
          method: "clear",
          ids: ids
        },
        success: res => {
          if (res.code == 200) {
            
            let numPru = 0
            for (let i = that.allPrudctList.length - 1; i >= 0; i--) {
            for (
              let j = that.allPrudctList[i].shop_info.length - 1;
              j >= 0;
              j--
            ) {
              if (that.allPrudctList[i].shop_info[j].pro_list.length) {
                numPru++
              }
            }
           
          }
            if (numPru == 0) {
              that.allPrudctList = []
            }

            
            if (
              that.flgManagement == 1 ||
              (that.flgManagement == 2 && that.allPrudctList.length == 0 && that.allFailureList.length == 0)
              // (that.flgManagement == 2 && that.allPrudctList.length == 0)
            ) {
              // 再次请求接口
              setTimeout(function() {
                that.againRequest();
              }, 400);
            }
          } else {
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
        },
        error: () => {
          let that = this
          //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.home_url;
          //       });
          // });
        }
      });
    },

    // 获取cookie的方法
    changeCookie(id, param_id, pro_num) {
      // 读取cookie
      let cartKey = this.$route.query.username + "_gouwuche",
        user_id = this.$cookies.get("zz_userid"),
        cart = this.$cookies.get(cartKey),
        data = {};

      // 获取 zz_userid判断是否登录
      if (user_id != undefined || user_id != null || user_id > 0) {
        this.zz_userid = user_id;
      } else {
        this.zz_userid = 0;
      }
      for (let k = 0; k < id.length; k++) {
        let key = parseInt(id[k]) + "_" + parseInt(param_id[k]);
        if (JSON.stringify(cart) != '{}' && cart != null) {
          data = cart;
          // 将data对象转化为数组
          for (let i in data) {
            if (key == i) {
              if (pro_num == 0) {
                // 删除对应的key值
                delete data[i];
                // 调用删除接口
                this.deleteDatas(key);

                // this.flgKey = key
              } else {
                data[key] = { num: pro_num };
              }
            } else {
              if (pro_num == 0) {
                this.deleteDatas(key);
              } else {
                data[key] = { num: pro_num };
              }
            }
          }
        } else {
          if (pro_num == 0) {
            this.deleteDatas(key);
          } else {
            data[key] = { num: pro_num };
          }
        }
      }

      // 存入cookie
      if (data) {
        this.$cookies.set(
          this.$route.query.username + "_gouwuche",
          JSON.stringify(data),
          3600 * 7
        );
      }

      // 再次调取所有接口
      // this.againRequest();
    },


    // 获取色系函数
    colorFun(value) {
      switch (value) {
        case "#469cb7":
          this.theme = 'color1'
          break;
        case "#b64d4a":
          this.theme = 'color2'
          break;
        case "#2f5e66":
          this.theme = 'color3'
          break;
        case "#77a0a6":
          this.theme = 'color4'
          break;
        case "#7f5935":
          this.theme = 'color5'
          break;
        case "#a5663b":
          this.theme = 'color6'
          break;
        case "#246b97":
          this.theme = 'color7'
          break;
        case "#4f803f":
          this.theme = 'color8'
          break;
        case "#941761":
          this.theme = 'color9'
          break;
        case "#201712":
          this.theme = 'color10'
          break;
        case "#73a65b":
          this.theme = 'color11'
          break;
        case "#ca528f":
          this.theme = 'color12'
          break;
        case "#1b919f":
          this.theme = 'color13'
          break;
        case "#dd627e":
          this.theme = 'color14'
          break;
        case "#40516d":
          this.theme = 'color15'
          break;
        case "#c78de2":
          this.theme = 'color16'
          break;
        case "#323e2a":
          this.theme = 'color17'
          break;
        case "#2e073e":
          this.theme = 'color18'
          break;
        case "#154d80":
          this.theme = 'color19'
          break;
        case "#65212e":
          this.theme = 'color20'
          break;
        case "#956652":
          this.theme = 'color21'
          break;
        case "#ff4500":
          this.theme = 'color22'
          break;
        case "#fea500":
          this.theme = 'color23'
          break;
        case "#fe0000":
          this.theme = 'color24'
          break;
        case "#1e90ff":
          this.theme = 'color25'
          break;
        case "#7f8000":
          this.theme = 'color26'
          break;
        case "#4682b4":
          this.theme = 'color27'
          break;
        case "#2e8a57":
          this.theme = 'color28'
          break;
        case "#000000":
          this.theme = 'color29'
          break;
        case "#4169e2":
          this.theme = 'color30'
          break;
        case "#ffd601":
          this.theme = 'color31'
          break;
        case "#4b0081":
          this.theme = 'color32'
          break;
        case "#8b4512":
          this.theme = 'color33'
          break;
        case "#ce8540":
          this.theme = 'color34'
          break;
        case "#d3691f":
          this.theme = 'color35'
          break;
        case "#483d8b":
          this.theme = 'color36'
          break;
        case "#ff1494":
          this.theme = 'color37'
          break;
        case "#566b30":
          this.theme = 'color38'
          break;
        case "#8c0000":
          this.theme = 'color39'
          break;
        case "#006401":
          this.theme = 'color40'
          break;
        case "#b8860b":
          this.theme = 'color41'
          break;
        case "#2f4f4e":
          this.theme = 'color42'
          break;
        case "#0000cc":
          this.theme = 'color43'
          break;
        case "#191971":
          this.theme = 'color44'
          break;
        case "#dc133d":
          this.theme = 'color45'
          break;
        case "#81007f":
          this.theme = 'color46'
          break;
      }
    },

    //touch Start事件
    touchStartFun(){
    // 调取倒计时
          this.getTimeFun();
    },
    //  touch Move事件
    touchMoveFun(){
    // 调取倒计时
          this.getTimeFun();
    },
    //  touch End事件
    touchEndFun(){
      // 调取倒计时
      this.getTimeFun();
    }
  },
  mounted() { 
    let that = this,
      user_id = this.$cookies.get("zz_userid");
    // 获取 zz_userid判断是否登录
    if ((user_id != undefined || user_id != null) && user_id > 0) {
      this.zz_userid = user_id;
    } else {
      this.zz_userid = 0;
    }

    var width = document.body.offsetWidth;
    var wdithpx = width / 2 - 37 / 2;
    //加载层-默认风格
    layui.use("layer", function() {
      layer.ready(function() {
        layer.load({
          shade: false
        });
      });
    });

    // 请求购物车列表接口
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: { username: this.$route.query.username },
        success: res => {
          if (res.code == 200) {
            setTimeout(function() {
                layui.use("layer", function() {
                  // 关闭loading
                  layer.closeAll("loading");
                });
              }, 400);
            let numInterface = that.numInterface;
            that.numInterface = numInterface + 1;
            if (that.numInterface == 2) {
              setTimeout(function() {
                layui.use("layer", function() {
                  // 关闭loading
                  layer.closeAll("loading");
                });
              }, 500);
            }
            that.allTextdata = res.data
            
            // title
            that.pageTitle = res.data.gouwuche
            // 金钱符号
            that.currency_symbol = res.data.currency_symbol;
            // 判读跳转方式
            that.return_type = res.data.return_type;
            // 首页链接
            that.home_url = res.data.home_url;
            // 登录页链接
            that.self_href = res.data.self_href;
            //总金额
            that.total_price = res.data.total_price;
            // 满减金额
            that.cut_money = res.data.cut_money;
            // 必须使用
            that.bixushiyong = res.data.bixushiyong;
            // 页面标题
            that.gouwuche = res.data.gouwuche;
            //购物车还是空的
            (that.gouwuchehaishikongde = res.data.gouwuchehaishikongde),
              // 活动已结束
              (that.huodongyijieshu = res.data.huodongyijieshu),
              // 减
              (that.jian = res.data.jian),
              // 据活动结束还剩
              (that.juhuodongjieshuhaisheng = res.data.juhuodongjieshuhaisheng),
              // 满
              (that.man = res.data.man),
              // 全选
              (that.quanxuan = res.data.quanxuan),
              // 去逛逛
              (that.quguangguang = res.data.quguangguang),
              // 删除
              (that.shanchu = res.data.shanchu),
              // 完成
              (that.wancheng = res.data.wancheng),
              // 消费积分重命名
              (that.xf_name = res.data.xf_name),
              // 详情
              (that.xiangqing = res.data.xiangqing),
              // 一键清空
              (that.yijianqingkong = res.data.yijianqingkong),
              // 已选
              (that.yixuan = res.data.yixuan),
              // 自营
              (that.ziying = res.data.ziying),
              // 重选
              (that.chongxuan = res.data.chongxuan),
              // 合计
              (that.heji = res.data.heji),
              // 请输入购买数量
              (that.qingshurugoumaishuliang = res.data.qingshurugoumaishuliang),
              // 确定要删除此商品吗?
              (that.quedingyaoshanchucishangpinma =
                res.data.quedingyaoshanchucishangpinma),
              // 确定要删除选中商品吗?
              (that.quedingyaoshanchuxuanzhongshangpinma =
                res.data.quedingyaoshanchuxuanzhongshangpinma),
              // 去结算
              (that.qujiesuan = res.data.qujiesuan),
              // 微团购
              (that.weituangou = res.data.weituangou),
              // 限时购
              (that.xianshigou = res.data.xianshigou),
              // 已售罄
              (that.yishouqing = res.data.yishouqing),
              // 已满减
              (that.yimanjian = res.data.yimanjian),
              // 已选
              (that.yixuan = res.data.yixuan);
            // 起售
            that.qishou = res.data.qishou;
            // 确认
            that.queren = res.data.queren;
            // 取消
            that.quxiao = res.data.quxiao;
            // 活动截止至
            that.huodongjiezhizhi = res.data.huodongjiezhizhi;
            // 已选件数
            // that.numFlg = res.data.numFlg;
            // 去逛逛链接
            that.home_url = res.data.home_url;
            // 管理
            that.guanli = res.data.guanli;
            // 更多可用商品
            that.gengduokeyongshangpin = res.data.gengduokeyongshangpin;
            // 活动时间
            that.huodongshijian = res.data.huodongshijian;
            // 代金券
            that.daijinquan = res.data.daijinquan;
            // 限购
            that.xiangou = res.data.xiangou;
            // 购买超过库存
            that.goumaichaoguokucun = res.data.goumaichaoguokucun;
            // 购买超过限购
            that.goumaichaoguoxiangou = res.data.goumaichaoguoxiangou;
            // 未到达最小起售数量
            that.weidadaozuixiaoqishoushuliang =
              res.data.weidadaozuixiaoqishoushuliang;
            // 件
            that.danweijian = res.data.danweijian;
            // 起售
            that.qishou = res.data.qishou;
            // 至
            that.zhi = res.data.zhi;
            // 收起
            that.shouqi = res.data.shouqi;

            // 所有商品数组
            let newData = res.data.all_pro;
            // 等于0的时候购物车没有数据
            if (newData.length == 0) {
              that.ifDate = false;
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
              return false;
            }
            if (newData.length > 0) {
              that.ifDate = true;
            }
            // 定义一个空数组,用来存储有效商品
            let allPrudctListValue = [];
            // 定义一个数组用来存放失效商品,
            let allFailureList = []
            // 用来判断,已选多少件
            let numFlg = 0;
             // 定义变量,用于判断去结算是否可点击
                let SettleFlg = 0;
            for (var i = 0; i < newData.length; i++) {
              // 失效商品
              if (newData[i].shop_id == -1) {
                allFailureList = newData[i].shop_info;
                that.allFailureListName = newData[i].shop_name;
                that.ifFailureDate = true;
              } else {
                // 自定义对象,用来加入优惠券
                let jsonPic = {};
                // 自定义数组
                let allIdList = [];
                // 自定义变量
                let LastIds = "";

                //有效商品
                newData[i].ifShow = 1;
                // 先加上值,而后在改变值,如果在改变值的时候加字段,渲染会出问题
                newData[i].ifPre = true;
                // 用来判断商铺是否选中
                let lengthVlaue = 0;
                // 用来判断商铺是否可选
                let shopIfChange = 0;

                // 添加字段,用于判断底部是否可选择
                newData[i].ifAllXuan = 0;
                // 判断是否可选的前提变量
                let dataAllXuan = 0;
               
              // 用来判断商铺是否可全选
              let shopIfValue2  = 0;
                for (let j = 0; j < newData[i].shop_info.length; j++) {
                  let isCheckValue = newData[i].shop_info[j].pro_list.filter(
                    item => item.is_check == 0
                  );
                  if (newData[i].shop_info[j].rule_type == 1) {
                    if (isCheckValue.length) {
                      newData[i].shop_info[j].is_pifaZu = 0;
                    } else {
                      // 添加一个字段用来判断组的显示情况
                      newData[i].shop_info[j].is_pifaZu = 1;
                    }
                  }

                  let shopIfValue = newData[i].shop_info[j].pro_list.filter(
                    item => item.is_buy == 1
                  );
                  if (shopIfValue.length) {
                    shopIfChange++;
                  }

                  // 添加字段用于判断商铺是否可选
                  newData[i].shopIfChange = shopIfChange;
                  for (
                    let k = 0;
                    k < newData[i].shop_info[j].pro_list.length;
                    k++
                  ) {

                    if (newData[i].shop_info[j].pro_list[k].is_buy == 1) {
                      dataAllXuan = 1;
                      lengthVlaue++
                    }
                    

                    if (newData[i].shop_info[j].pro_list[k].is_check == 1) {
                      SettleFlg = 1;
                      numFlg++
                    }

                    if(newData[i].shop_info[j].pro_list[k].pro_type == 4){
                    that.pro_type_value = 1

                    // 获取本地时间(时间戳)
                    let dateLocal = Date.parse(new Date());
                    // 获取差值
                    let difference =
                      parseInt(
                        Date.parse(newData[i].shop_info[j].pro_list[k].end_time)
                      ) - parseInt(dateLocal);

                    // 将时间戳转换为时间
                    var days = parseInt(difference / (1000 * 60 * 60 * 24));
                    var hours = parseInt(
                      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                    );
                    var minutes = parseInt(
                      (difference % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    var seconds = (difference % (1000 * 60)) / 1000;
                    var JsonTime = {
                      days: days,
                      hours: hours,
                      minutes: minutes,
                      seconds: seconds
                    };
                    newData[i].shop_info[j].pro_list[k].JsonTime = JsonTime;
                    }

                  }

                 let shopIfValue3 = newData[i].shop_info[j].pro_list.filter(
                    item => item.is_check == 1
                  );
                  shopIfValue2 = shopIfValue3.length + shopIfValue2
                
                }

                if (shopIfValue2 == lengthVlaue) {
                  newData[i].ifShow = 1;
                } else {
                  newData[i].ifShow = 0;
                }

                //  判断用于商铺全选
                  let if_quanxuan = newData.filter(function(e) {
                    return e.ifShow == 0;
                  });
                  if (if_quanxuan.length) {
                    that.shoppingContent_radioFlg = false;
                  } else {
                    that.shoppingContent_radioFlg = true;
                  }
               

                // 判断用于底部全选按钮
                if (dataAllXuan) {
                  newData[i].ifAllXuan = 1;
                } else {
                  newData[i].ifAllXuan = 0;
                }

                // allIdList.push(ids.slice(0, ids.length - 1));
                allPrudctListValue.push(newData[i]);
              }
            }

            // 判断去结算是否可点击
                if(SettleFlg){
                  that.clickSettlement = true;
                }else{
                  that.clickSettlement = false
                }
             // 判断已选多少件
                that.numFlg = numFlg;

            

            // 判断用于底部全选
            let if_ifAllXuan = newData.filter(function(e) {
              return e.ifAllXuan == 0;
            });
            if (if_ifAllXuan.length) {
              that.shoppingContent_radioFlg_no = false;
            } else {
              that.shoppingContent_radioFlg_no = true;
            }
            // 非失效商品
            that.allPrudctList = allPrudctListValue;
            // 失效商品
            that.allFailureList  = allFailureList

            that.getTimeFun();

            if (that.idsFlg != -1) {
            }
          } else if (res.data.code == 30001) {
            let numInterface2 = that.numInterface;
            that.numInterface = numInterface2 + 1;
            // 让没有商品显示
            that.ifDate = false;
            if (that.numInterface == 2) {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.data.message, {
                icon: 0,
                skin: "layer-ext-moon"
              },function () {
                   location.href = that.home_url;
                });
            });
          } else {
            let numInterface3 = that.numInterface;
            that.numInterface = numInterface3 + 1;
            if (that.numInterface == 2) {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }
            //警告信息
            // 让商品显示
            that.ifDate = true;
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              },function () {
                   location.href = res.data.home_url;
                });
            });
          }
        },
        error() {
          layui.use("layer", function() {
            // 关闭loading
            layer.ready(function() {
              layer.closeAll("loading");
            });
          });
          layui.use("layer", ()=> {
            layer.alert("请求失败", {
              icon: 0,
              skin: "layer-ext-moon"
            }, ()=> {
                   location.href = '/wap_'+ this.$route.query.username +'.html';
                });
          });
        }
      });

    // 请求购物车活动信息
    this.$F.Response({
      url: "mallorder/api/cart.php",
      param: { username: this.$route.query.username, method: "active" },
      success: res => {
        if (res.code == 200) {
          let numInterface = that.numInterface;
          that.numInterface = numInterface + 1;

          that.acvityList = res.data;

          if (that.numInterface == 2) {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }
        } else {
          let numInterface2 = that.numInterface;
          that.numInterface = numInterface2 + 1;
          if (that.numInterface == 2) {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }
          //警告信息
          // 让商品显示
          that.ifDate = true;
          //弹出警示信息
          layui.use("layer", function() {
            layer.alert(res.message, {
              icon: 0,
              skin: "layer-ext-moon"
            });
          });
        }
      },
      error() {
        let that = this
        setTimeout(function() {
          layui.use("layer", function() {
            // 关闭loading
            layer.closeAll("loading");
          });
        }, 300);

        //弹出警示信息
        // layui.use("layer", function() {
        //   layer.alert("请求失败", {
        //     icon: 0,
        //     skin: "layer-ext-moon"
        //   },function () {
        //            location.href = that.home_url;
        //         });
        // });
      }
    });

    // 色系接口
    this.$F.Response({
      url: "mallorder/api/cart.php",
      param: { username: this.$route.query.username, method: "public" },
      success: res => {
        if (res.code == 200) {
          // 调取颜色
            setTimeout(function() {
              that.colorFun(res.data.color);
            }, 300);
        } else {
          //警告信息
          //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert(res.msg, {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   });
          // });
        }
      },
      error() {
        // let that = this
        // //弹出警示信息
        // layui.use("layer", function() {
        //   layer.alert("请求失败", {
        //     icon: 0,
        //     skin: "layer-ext-moon"
        //   },function () {
        //            location.href = that.home_url;
        //         });
        // });
      }
    });
  }
};
</script>

<style scoped lang="scss">
// 引入外部scss文件
@import "../../../static/css/shoppingCat.scss";

// 引入色系值
@import "../../../static/css/color.scss"
</style>



// WEBPACK FOOTER //
// src/pages/ShoppingCat/ShoppingCat.vue